function PlanII({ ...props }) {
	return (
		<g {...props} id="unit-ii">
			<g id="furniture">
				<polyline
					points="306.56 761.13 306.56 758.15 312.45 758.15 312.45 761.13 306.56 761.13"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="739.57"
					y1="570.05"
					x2="926.16"
					y2="570.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="926.16"
					y1="614.76"
					x2="920.86"
					y2="614.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="916.56"
					y1="614.76"
					x2="909.41"
					y2="614.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="905.12"
					y1="614.76"
					x2="897.97"
					y2="614.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="893.67"
					y1="614.76"
					x2="886.52"
					y2="614.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="882.23"
					y1="614.76"
					x2="875.07"
					y2="614.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="870.78"
					y1="614.76"
					x2="863.63"
					y2="614.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="859.34"
					y1="614.76"
					x2="852.18"
					y2="614.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="847.89"
					y1="614.76"
					x2="840.73"
					y2="614.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="836.44"
					y1="614.76"
					x2="829.29"
					y2="614.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="825"
					y1="614.76"
					x2="817.84"
					y2="614.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="813.55"
					y1="614.76"
					x2="806.4"
					y2="614.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="802.11"
					y1="614.76"
					x2="794.95"
					y2="614.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="790.66"
					y1="614.76"
					x2="783.5"
					y2="614.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="779.21"
					y1="614.76"
					x2="772.06"
					y2="614.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="739.57"
					y1="591.75"
					x2="739.57"
					y2="584.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="739.57"
					y1="580.31"
					x2="739.57"
					y2="573.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="739.57"
					y1="573.03"
					x2="744.88"
					y2="573.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="749.17"
					y1="573.03"
					x2="756.32"
					y2="573.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="760.61"
					y1="573.03"
					x2="767.76"
					y2="573.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="772.06"
					y1="573.03"
					x2="779.21"
					y2="573.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="783.5"
					y1="573.03"
					x2="790.66"
					y2="573.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="794.95"
					y1="573.03"
					x2="802.11"
					y2="573.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="806.4"
					y1="573.03"
					x2="813.55"
					y2="573.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="817.84"
					y1="573.03"
					x2="825"
					y2="573.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="829.29"
					y1="573.03"
					x2="836.44"
					y2="573.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="840.73"
					y1="573.03"
					x2="847.89"
					y2="573.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="852.18"
					y1="573.03"
					x2="859.34"
					y2="573.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="863.63"
					y1="573.03"
					x2="870.78"
					y2="573.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="875.07"
					y1="573.03"
					x2="882.23"
					y2="573.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="886.52"
					y1="573.03"
					x2="893.67"
					y2="573.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="897.97"
					y1="573.03"
					x2="905.12"
					y2="573.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="909.41"
					y1="573.03"
					x2="916.56"
					y2="573.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="920.86"
					y1="573.03"
					x2="926.16"
					y2="573.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="926.16"
					y1="573.03"
					x2="926.16"
					y2="580.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="926.16"
					y1="607.49"
					x2="926.16"
					y2="614.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="567.98 823.78 648.46 823.78 648.46 904.26 567.98 904.26 567.98 823.78"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="833.98 70 780.39 70 780.39 76.46 833.98 76.46 833.98 70"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="778.04 69.42 836.32 69.42 836.32 70 778.04 70 778.04 69.42"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="778.04"
					y1="69.42"
					x2="836.32"
					y2="69.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="836.32"
					y1="69.42"
					x2="836.32"
					y2="70"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="836.32"
					y1="70"
					x2="778.04"
					y2="70"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="778.04"
					y1="70"
					x2="778.04"
					y2="69.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="833.98"
					y1="76.46"
					x2="780.39"
					y2="76.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="780.39"
					y1="70"
					x2="833.98"
					y2="70"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="839.26 76.46 833.98 76.46 833.98 70 839.26 70 839.26 76.46"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="839.26"
					y1="76.46"
					x2="833.98"
					y2="76.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="833.98"
					y1="76.46"
					x2="833.98"
					y2="70"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="833.98"
					y1="70"
					x2="839.26"
					y2="70"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="839.26"
					y1="70"
					x2="839.26"
					y2="76.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="775.11 70 780.39 70 780.39 76.46 775.11 76.46 775.11 70"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="775.11"
					y1="70"
					x2="780.39"
					y2="70"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="780.39"
					y1="70"
					x2="780.39"
					y2="76.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="780.39"
					y1="76.46"
					x2="775.11"
					y2="76.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="775.11"
					y1="76.46"
					x2="775.11"
					y2="70"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="833.98"
					y1="71.18"
					x2="780.39"
					y2="71.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="841.6 75.87 839.26 75.87 839.26 70 836.32 70 836.32 69.42 841.6 69.42 841.6 75.87"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="841.6"
					y1="75.87"
					x2="839.26"
					y2="75.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="839.26"
					y1="75.87"
					x2="839.26"
					y2="70"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="839.26"
					y1="70"
					x2="836.32"
					y2="70"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="836.32"
					y1="70"
					x2="836.32"
					y2="69.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="836.32"
					y1="69.42"
					x2="841.6"
					y2="69.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="841.6"
					y1="69.42"
					x2="841.6"
					y2="75.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="772.76 69.42 778.04 69.42 778.04 70 775.11 70 775.11 75.87 772.76 75.87 772.76 69.42"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="772.76"
					y1="69.42"
					x2="778.04"
					y2="69.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="778.04"
					y1="69.42"
					x2="778.04"
					y2="70"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="778.04"
					y1="70"
					x2="775.11"
					y2="70"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="775.11"
					y1="70"
					x2="775.11"
					y2="75.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="775.11"
					y1="75.87"
					x2="772.76"
					y2="75.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="772.76"
					y1="75.87"
					x2="772.76"
					y2="69.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="769.78 71.18 769.78 74.16 669.33 74.16 669.33 71.18 769.78 71.18"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="769.78"
					y1="71.18"
					x2="769.78"
					y2="74.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="769.78"
					y1="74.16"
					x2="669.33"
					y2="74.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="669.33"
					y1="74.16"
					x2="669.33"
					y2="71.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="669.33"
					y1="71.18"
					x2="769.78"
					y2="71.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="841.6 71.18 847.57 71.18 847.57 89.06 841.6 89.06 841.6 71.18"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="847.57"
					y1="71.18"
					x2="841.6"
					y2="71.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="847.57"
					y1="89.06"
					x2="847.57"
					y2="71.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="841.6"
					y1="89.06"
					x2="847.57"
					y2="89.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="841.6"
					y1="71.18"
					x2="841.6"
					y2="89.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="766.8 71.18 772.76 71.18 772.76 89.06 766.8 89.06 766.8 71.18"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="772.76"
					y1="71.18"
					x2="766.8"
					y2="71.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="772.76"
					y1="89.06"
					x2="772.76"
					y2="71.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="766.8"
					y1="89.06"
					x2="772.76"
					y2="89.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="766.8"
					y1="71.18"
					x2="766.8"
					y2="89.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="666.35 71.18 672.31 71.18 672.31 89.06 666.35 89.06 666.35 71.18"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="672.31"
					y1="71.18"
					x2="666.35"
					y2="71.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="672.31"
					y1="89.06"
					x2="672.31"
					y2="71.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="666.35"
					y1="89.06"
					x2="672.31"
					y2="89.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="666.35"
					y1="71.18"
					x2="666.35"
					y2="89.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="455.82 70 402.24 70 402.24 76.46 455.82 76.46 455.82 70"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="399.89 69.42 458.17 69.42 458.17 70 399.89 70 399.89 69.42"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="399.89"
					y1="69.42"
					x2="458.17"
					y2="69.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="458.17"
					y1="69.42"
					x2="458.17"
					y2="70"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="458.17"
					y1="70"
					x2="399.89"
					y2="70"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="399.89"
					y1="70"
					x2="399.89"
					y2="69.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="455.82"
					y1="76.46"
					x2="402.24"
					y2="76.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="402.24"
					y1="70"
					x2="455.82"
					y2="70"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="461.1 76.46 455.82 76.46 455.82 70 461.1 70 461.1 76.46"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="461.1"
					y1="76.46"
					x2="455.82"
					y2="76.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="455.82"
					y1="76.46"
					x2="455.82"
					y2="70"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="455.82"
					y1="70"
					x2="461.1"
					y2="70"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="461.1"
					y1="70"
					x2="461.1"
					y2="76.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="396.96 70 402.24 70 402.24 76.46 396.96 76.46 396.96 70"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="396.96"
					y1="70"
					x2="402.24"
					y2="70"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="402.24"
					y1="70"
					x2="402.24"
					y2="76.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="402.24"
					y1="76.46"
					x2="396.96"
					y2="76.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="396.96"
					y1="76.46"
					x2="396.96"
					y2="70"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="455.82"
					y1="71.18"
					x2="402.24"
					y2="71.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="463.45 75.87 461.1 75.87 461.1 70 458.17 70 458.17 69.42 463.45 69.42 463.45 75.87"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="463.45"
					y1="75.87"
					x2="461.1"
					y2="75.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="461.1"
					y1="75.87"
					x2="461.1"
					y2="70"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="461.1"
					y1="70"
					x2="458.17"
					y2="70"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="458.17"
					y1="70"
					x2="458.17"
					y2="69.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="458.17"
					y1="69.42"
					x2="463.45"
					y2="69.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="463.45"
					y1="69.42"
					x2="463.45"
					y2="75.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="394.61 69.42 399.89 69.42 399.89 70 396.96 70 396.96 75.87 394.61 75.87 394.61 69.42"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="394.61"
					y1="69.42"
					x2="399.89"
					y2="69.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="399.89"
					y1="69.42"
					x2="399.89"
					y2="70"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="399.89"
					y1="70"
					x2="396.96"
					y2="70"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="396.96"
					y1="70"
					x2="396.96"
					y2="75.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="396.96"
					y1="75.87"
					x2="394.61"
					y2="75.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="394.61"
					y1="75.87"
					x2="394.61"
					y2="69.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="391.63 71.18 391.63 74.16 237.94 74.16 237.94 71.18 391.63 71.18"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="391.63"
					y1="71.18"
					x2="391.63"
					y2="74.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="391.63"
					y1="74.16"
					x2="237.94"
					y2="74.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="237.94"
					y1="74.16"
					x2="237.94"
					y2="71.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="237.94"
					y1="71.18"
					x2="391.63"
					y2="71.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="463.45 71.18 469.41 71.18 469.41 89.06 463.45 89.06 463.45 71.18"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="469.41"
					y1="71.18"
					x2="463.45"
					y2="71.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="469.41"
					y1="89.06"
					x2="469.41"
					y2="71.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="463.45"
					y1="89.06"
					x2="469.41"
					y2="89.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="463.45"
					y1="71.18"
					x2="463.45"
					y2="89.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="388.65 71.18 394.61 71.18 394.61 89.06 388.65 89.06 388.65 71.18"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="394.61"
					y1="71.18"
					x2="388.65"
					y2="71.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="394.61"
					y1="89.06"
					x2="394.61"
					y2="71.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="388.65"
					y1="89.06"
					x2="394.61"
					y2="89.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="388.65"
					y1="71.18"
					x2="388.65"
					y2="89.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="234.96 71.18 240.92 71.18 240.92 89.06 234.96 89.06 234.96 71.18"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="240.92"
					y1="71.18"
					x2="234.96"
					y2="71.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="240.92"
					y1="89.06"
					x2="240.92"
					y2="71.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="234.96"
					y1="89.06"
					x2="240.92"
					y2="89.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="234.96"
					y1="71.18"
					x2="234.96"
					y2="89.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="526.98"
					y1="877.6"
					x2="531.45"
					y2="877.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="526.98"
					y1="853.75"
					x2="531.45"
					y2="853.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="526.98"
					y1="853.75"
					x2="526.98"
					y2="877.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="413.71"
					y1="877.6"
					x2="409.24"
					y2="877.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="413.71"
					y1="853.75"
					x2="409.24"
					y2="853.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="413.71"
					y1="853.75"
					x2="413.71"
					y2="877.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="526.98"
					y1="877.6"
					x2="531.45"
					y2="877.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<polyline
					points="415.2 879.08 415.2 877.6 409.24 877.6 409.24 879.08 415.2 879.08"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="525.49 877.6 525.49 879.08 531.45 879.08 531.45 877.6 525.49 877.6"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="415.2 853.75 415.2 852.26 409.24 852.26 409.24 853.75 415.2 853.75"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="525.49 852.26 525.49 853.75 531.45 853.75 531.45 852.26 525.49 852.26"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="415.2"
					y1="879.08"
					x2="409.24"
					y2="879.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="409.24"
					y1="879.08"
					x2="409.24"
					y2="877.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="409.24"
					y1="877.6"
					x2="415.2"
					y2="877.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="415.2"
					y1="877.6"
					x2="415.2"
					y2="879.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="525.49"
					y1="877.6"
					x2="531.45"
					y2="877.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="531.45"
					y1="877.6"
					x2="531.45"
					y2="879.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="531.45"
					y1="879.08"
					x2="525.49"
					y2="879.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="525.49"
					y1="879.08"
					x2="525.49"
					y2="877.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="415.2"
					y1="853.75"
					x2="409.24"
					y2="853.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="409.24"
					y1="853.75"
					x2="409.24"
					y2="852.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="409.24"
					y1="852.26"
					x2="415.2"
					y2="852.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="415.2"
					y1="852.26"
					x2="415.2"
					y2="853.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="525.49"
					y1="852.26"
					x2="531.45"
					y2="852.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="531.45"
					y1="852.26"
					x2="531.45"
					y2="853.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="531.45"
					y1="853.75"
					x2="525.49"
					y2="853.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="525.49"
					y1="853.75"
					x2="525.49"
					y2="852.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="416.69 877.6 416.69 853.75 414.46 853.75 414.46 877.6 416.69 877.6"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="526.24 877.6 526.24 853.75 524 853.75 524 877.6 526.24 877.6"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="448.12 777.87 444.43 781.56 520.31 857.44 524 853.75 448.12 777.87"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="414.46"
					y1="853.75"
					x2="413.71"
					y2="853.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="414.46"
					y1="877.6"
					x2="413.71"
					y2="877.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="413.71"
					y1="853.75"
					x2="413.71"
					y2="877.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="526.24"
					y1="853.75"
					x2="526.98"
					y2="853.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="526.24"
					y1="877.6"
					x2="526.98"
					y2="877.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="526.98"
					y1="853.75"
					x2="526.98"
					y2="877.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="416.69"
					y1="877.6"
					x2="416.69"
					y2="853.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="416.69"
					y1="853.75"
					x2="414.46"
					y2="853.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="414.46"
					y1="853.75"
					x2="414.46"
					y2="877.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="414.46"
					y1="877.6"
					x2="416.69"
					y2="877.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="526.24"
					y1="877.6"
					x2="526.24"
					y2="853.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="526.24"
					y1="853.75"
					x2="524"
					y2="853.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="524"
					y1="853.75"
					x2="524"
					y2="877.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="524"
					y1="877.6"
					x2="526.24"
					y2="877.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="448.12"
					y1="777.87"
					x2="444.43"
					y2="781.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="444.43"
					y1="781.56"
					x2="520.31"
					y2="857.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="520.31"
					y1="857.44"
					x2="524"
					y2="853.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="524"
					y1="853.75"
					x2="448.12"
					y2="777.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="413.71"
					y1="853.75"
					x2="413.71"
					y2="877.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="413.71"
					y1="853.75"
					x2="413.71"
					y2="877.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="413.71"
					y1="853.75"
					x2="409.24"
					y2="853.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="413.71"
					y1="853.75"
					x2="409.24"
					y2="853.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="413.71"
					y1="877.6"
					x2="409.24"
					y2="877.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="413.71"
					y1="877.6"
					x2="409.24"
					y2="877.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="526.98"
					y1="853.75"
					x2="526.98"
					y2="877.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="526.98"
					y1="853.75"
					x2="526.98"
					y2="877.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="526.98"
					y1="853.75"
					x2="531.45"
					y2="853.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="526.98"
					y1="853.75"
					x2="531.45"
					y2="853.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="526.98"
					y1="877.6"
					x2="531.45"
					y2="877.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="526.98"
					y1="877.6"
					x2="531.45"
					y2="877.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="531.45"
					y1="877.6"
					x2="531.45"
					y2="934.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="555.3"
					y1="853.75"
					x2="555.3"
					y2="877.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="555.3"
					y1="910.94"
					x2="555.3"
					y2="877.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="888.27"
					y1="910.94"
					x2="706.87"
					y2="910.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="888.27"
					y1="805.21"
					x2="888.27"
					y2="910.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="888.27"
					y1="805.21"
					x2="903.17"
					y2="805.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="911.21"
					y1="805.21"
					x2="903.17"
					y2="805.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="926.16"
					y1="614.76"
					x2="911.21"
					y2="614.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="847.57"
					y1="65.22"
					x2="847.57"
					y2="89.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="655.91"
					y1="815.31"
					x2="660.38"
					y2="815.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="655.91"
					y1="800.41"
					x2="660.38"
					y2="800.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="655.91"
					y1="800.41"
					x2="655.91"
					y2="815.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="560.52"
					y1="815.31"
					x2="556.05"
					y2="815.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="560.52"
					y1="800.41"
					x2="556.05"
					y2="800.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="560.52"
					y1="800.41"
					x2="560.52"
					y2="815.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="555.3"
					y1="815.31"
					x2="560.52"
					y2="815.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="655.91"
					y1="815.31"
					x2="661.13"
					y2="815.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="560.52"
					y1="800.41"
					x2="555.3"
					y2="800.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<polyline
					points="562.01 816.8 562.01 815.31 556.05 815.31 556.05 816.8 562.01 816.8"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="654.42 815.31 654.42 816.8 660.38 816.8 660.38 815.31 654.42 815.31"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="562.01 800.41 562.01 798.92 556.05 798.92 556.05 800.41 562.01 800.41"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="654.42 798.92 654.42 800.41 660.38 800.41 660.38 798.92 654.42 798.92"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="562.01"
					y1="816.8"
					x2="556.05"
					y2="816.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="556.05"
					y1="816.8"
					x2="556.05"
					y2="815.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="556.05"
					y1="815.31"
					x2="562.01"
					y2="815.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="562.01"
					y1="815.31"
					x2="562.01"
					y2="816.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="654.42"
					y1="815.31"
					x2="660.38"
					y2="815.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="660.38"
					y1="815.31"
					x2="660.38"
					y2="816.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="660.38"
					y1="816.8"
					x2="654.42"
					y2="816.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="654.42"
					y1="816.8"
					x2="654.42"
					y2="815.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="562.01"
					y1="800.41"
					x2="556.05"
					y2="800.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="556.05"
					y1="800.41"
					x2="556.05"
					y2="798.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="556.05"
					y1="798.92"
					x2="562.01"
					y2="798.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="562.01"
					y1="798.92"
					x2="562.01"
					y2="800.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="654.42"
					y1="798.92"
					x2="660.38"
					y2="798.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="660.38"
					y1="798.92"
					x2="660.38"
					y2="800.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="660.38"
					y1="800.41"
					x2="654.42"
					y2="800.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="654.42"
					y1="800.41"
					x2="654.42"
					y2="798.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="563.5 815.31 563.5 800.41 561.27 800.41 561.27 815.31 563.5 815.31"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="655.16 815.31 655.16 800.41 652.93 800.41 652.93 815.31 655.16 815.31"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="589.7 737.17 586.01 740.86 649.24 804.09 652.93 800.41 589.7 737.17"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="561.27"
					y1="800.41"
					x2="560.52"
					y2="800.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="561.27"
					y1="815.31"
					x2="560.52"
					y2="815.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="560.52"
					y1="800.41"
					x2="560.52"
					y2="815.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="655.16"
					y1="800.41"
					x2="655.91"
					y2="800.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="655.16"
					y1="815.31"
					x2="655.91"
					y2="815.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="655.91"
					y1="800.41"
					x2="655.91"
					y2="815.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="563.5"
					y1="815.31"
					x2="563.5"
					y2="800.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="563.5"
					y1="800.41"
					x2="561.27"
					y2="800.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="561.27"
					y1="800.41"
					x2="561.27"
					y2="815.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="561.27"
					y1="815.31"
					x2="563.5"
					y2="815.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="655.16"
					y1="815.31"
					x2="655.16"
					y2="800.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="655.16"
					y1="800.41"
					x2="652.93"
					y2="800.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="652.93"
					y1="800.41"
					x2="652.93"
					y2="815.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="652.93"
					y1="815.31"
					x2="655.16"
					y2="815.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="589.7"
					y1="737.17"
					x2="586.01"
					y2="740.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="586.01"
					y1="740.86"
					x2="649.24"
					y2="804.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="649.24"
					y1="804.09"
					x2="652.93"
					y2="800.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="652.93"
					y1="800.41"
					x2="589.7"
					y2="737.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="560.52"
					y1="800.41"
					x2="560.52"
					y2="815.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="560.52"
					y1="800.41"
					x2="560.52"
					y2="815.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="560.52"
					y1="800.41"
					x2="556.05"
					y2="800.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="560.52"
					y1="800.41"
					x2="556.05"
					y2="800.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="560.52"
					y1="815.31"
					x2="556.05"
					y2="815.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="560.52"
					y1="815.31"
					x2="556.05"
					y2="815.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="655.91"
					y1="800.41"
					x2="655.91"
					y2="815.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="655.91"
					y1="800.41"
					x2="655.91"
					y2="815.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="655.91"
					y1="800.41"
					x2="660.38"
					y2="800.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="655.91"
					y1="800.41"
					x2="660.38"
					y2="800.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="655.91"
					y1="815.31"
					x2="660.38"
					y2="815.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="655.91"
					y1="815.31"
					x2="660.38"
					y2="815.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="691.97"
					y1="645.82"
					x2="691.97"
					y2="641.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="706.87"
					y1="645.82"
					x2="706.87"
					y2="641.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="706.87"
					y1="645.82"
					x2="691.97"
					y2="645.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<polyline
					points="691.97 647.31 691.97 641.35 690.48 641.35 690.48 647.31 691.97 647.31"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="708.36 647.31 708.36 641.35 706.87 641.35 706.87 647.31 708.36 647.31"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="691.97"
					y1="647.31"
					x2="691.97"
					y2="641.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="691.97"
					y1="641.35"
					x2="690.48"
					y2="641.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="690.48"
					y1="641.35"
					x2="690.48"
					y2="647.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="690.48"
					y1="647.31"
					x2="691.97"
					y2="647.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="708.36"
					y1="739.71"
					x2="706.87"
					y2="739.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="708.36"
					y1="647.31"
					x2="708.36"
					y2="641.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="708.36"
					y1="641.35"
					x2="706.87"
					y2="641.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="706.87"
					y1="641.35"
					x2="706.87"
					y2="647.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="706.87"
					y1="647.31"
					x2="708.36"
					y2="647.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="691.97 646.56 691.97 648.8 706.87 648.8 706.87 646.56 691.97 646.56"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="770.1 712.03 706.87 648.8 703.18 652.49 766.41 715.72 770.1 712.03"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="706.87"
					y1="740.46"
					x2="706.87"
					y2="741.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="706.87"
					y1="646.56"
					x2="706.87"
					y2="645.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="691.97"
					y1="646.56"
					x2="691.97"
					y2="645.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="706.87"
					y1="645.82"
					x2="691.97"
					y2="645.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="706.87"
					y1="738.22"
					x2="706.87"
					y2="740.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="691.97"
					y1="646.56"
					x2="706.87"
					y2="646.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="706.87"
					y1="646.56"
					x2="706.87"
					y2="648.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="706.87"
					y1="648.8"
					x2="691.97"
					y2="648.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="691.97"
					y1="648.8"
					x2="691.97"
					y2="646.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="770.1"
					y1="712.03"
					x2="766.41"
					y2="715.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="766.41"
					y1="715.72"
					x2="703.18"
					y2="652.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="703.18"
					y1="652.49"
					x2="706.87"
					y2="648.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="706.87"
					y1="648.8"
					x2="770.1"
					y2="712.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="706.87"
					y1="645.82"
					x2="691.97"
					y2="645.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="706.87"
					y1="645.82"
					x2="691.97"
					y2="645.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="706.87"
					y1="645.82"
					x2="706.87"
					y2="641.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="706.87"
					y1="645.82"
					x2="706.87"
					y2="641.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="691.97"
					y1="645.82"
					x2="691.97"
					y2="641.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="691.97"
					y1="645.82"
					x2="691.97"
					y2="641.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="573.8"
					y1="629.67"
					x2="569.32"
					y2="629.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="573.8"
					y1="614.76"
					x2="569.32"
					y2="614.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="573.8"
					y1="614.76"
					x2="573.8"
					y2="629.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="669.18"
					y1="629.67"
					x2="673.65"
					y2="629.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="669.18"
					y1="614.76"
					x2="673.65"
					y2="614.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="669.18"
					y1="614.76"
					x2="669.18"
					y2="629.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="573.8"
					y1="614.76"
					x2="568.5"
					y2="614.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<polyline
					points="667.69 631.16 673.65 631.16 673.65 629.67 667.69 629.67 667.69 631.16"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="575.28 629.67 569.32 629.67 569.32 631.16 575.28 631.16 575.28 629.67"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="667.69 614.76 673.65 614.76 673.65 613.27 667.69 613.27 667.69 614.76"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="575.28 613.27 569.32 613.27 569.32 614.76 575.28 614.76 575.28 613.27"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="667.69"
					y1="631.16"
					x2="673.65"
					y2="631.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="673.65"
					y1="631.16"
					x2="673.65"
					y2="629.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="673.65"
					y1="629.67"
					x2="667.69"
					y2="629.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="667.69"
					y1="629.67"
					x2="667.69"
					y2="631.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="575.28"
					y1="629.67"
					x2="569.32"
					y2="629.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="569.32"
					y1="629.67"
					x2="569.32"
					y2="631.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="569.32"
					y1="631.16"
					x2="575.28"
					y2="631.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="575.28"
					y1="631.16"
					x2="575.28"
					y2="629.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="667.69"
					y1="614.76"
					x2="673.65"
					y2="614.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="673.65"
					y1="614.76"
					x2="673.65"
					y2="613.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="673.65"
					y1="613.27"
					x2="667.69"
					y2="613.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="667.69"
					y1="613.27"
					x2="667.69"
					y2="614.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="575.28"
					y1="613.27"
					x2="569.32"
					y2="613.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="569.32"
					y1="613.27"
					x2="569.32"
					y2="614.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="569.32"
					y1="614.76"
					x2="575.28"
					y2="614.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="575.28"
					y1="614.76"
					x2="575.28"
					y2="613.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="666.2 629.67 668.43 629.67 668.43 614.76 666.2 614.76 666.2 629.67"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="574.54 629.67 576.78 629.67 576.78 614.76 574.54 614.76 574.54 629.67"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="640.01 551.53 576.78 614.76 580.46 618.45 643.7 555.22 640.01 551.53"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="668.43"
					y1="614.76"
					x2="669.18"
					y2="614.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="668.43"
					y1="629.67"
					x2="669.18"
					y2="629.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="669.18"
					y1="614.76"
					x2="669.18"
					y2="629.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="574.54"
					y1="614.76"
					x2="573.8"
					y2="614.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="574.54"
					y1="629.67"
					x2="573.8"
					y2="629.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="573.8"
					y1="614.76"
					x2="573.8"
					y2="629.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="666.2"
					y1="629.67"
					x2="666.2"
					y2="614.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="666.2"
					y1="614.76"
					x2="668.43"
					y2="614.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="668.43"
					y1="614.76"
					x2="668.43"
					y2="629.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="668.43"
					y1="629.67"
					x2="666.2"
					y2="629.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="574.54"
					y1="629.67"
					x2="574.54"
					y2="614.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="574.54"
					y1="614.76"
					x2="576.78"
					y2="614.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="576.78"
					y1="614.76"
					x2="576.78"
					y2="629.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="576.78"
					y1="629.67"
					x2="574.54"
					y2="629.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="640.01"
					y1="551.53"
					x2="643.7"
					y2="555.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="643.7"
					y1="555.22"
					x2="580.46"
					y2="618.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="580.46"
					y1="618.45"
					x2="576.78"
					y2="614.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="576.78"
					y1="614.76"
					x2="640.01"
					y2="551.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="669.18"
					y1="614.76"
					x2="669.18"
					y2="629.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="669.18"
					y1="614.76"
					x2="669.18"
					y2="629.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="669.18"
					y1="614.76"
					x2="673.65"
					y2="614.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="669.18"
					y1="614.76"
					x2="673.65"
					y2="614.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="669.18"
					y1="629.67"
					x2="673.65"
					y2="629.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="669.18"
					y1="629.67"
					x2="673.65"
					y2="629.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="573.8"
					y1="614.76"
					x2="573.8"
					y2="629.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="573.8"
					y1="614.76"
					x2="573.8"
					y2="629.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="573.8"
					y1="614.76"
					x2="569.32"
					y2="614.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="573.8"
					y1="614.76"
					x2="569.32"
					y2="614.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="573.8"
					y1="629.67"
					x2="569.32"
					y2="629.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="573.8"
					y1="629.67"
					x2="569.32"
					y2="629.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="747.17"
					y1="539.46"
					x2="743.44"
					y2="539.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="747.17"
					y1="536.48"
					x2="747.17"
					y2="539.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="747.17"
					y1="524.55"
					x2="743.44"
					y2="524.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="747.17"
					y1="524.55"
					x2="747.17"
					y2="536.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="918.56"
					y1="539.46"
					x2="922.29"
					y2="539.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="918.56"
					y1="536.48"
					x2="918.56"
					y2="539.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="918.56"
					y1="524.55"
					x2="922.29"
					y2="524.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="918.56"
					y1="524.55"
					x2="918.56"
					y2="536.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="739.57"
					y1="539.46"
					x2="747.17"
					y2="539.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="918.56"
					y1="539.46"
					x2="926.16"
					y2="539.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="926.16"
					y1="524.55"
					x2="918.56"
					y2="524.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="747.17"
					y1="524.55"
					x2="739.57"
					y2="524.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<polyline
					points="916.33 536.48 916.33 539.46 917.82 539.46 917.82 536.48 916.33 536.48"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="916.33 540.95 922.29 540.95 922.29 539.46 916.33 539.46 916.33 540.95"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="747.91 536.48 747.91 539.46 749.4 539.46 749.4 536.48 747.91 536.48"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="749.4 539.46 743.44 539.46 743.44 540.95 749.4 540.95 749.4 539.46"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="916.33 524.55 922.29 524.55 922.29 520.83 916.33 520.83 916.33 524.55"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="749.4 520.83 743.44 520.83 743.44 524.55 749.4 524.55 749.4 520.83"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="916.33"
					y1="536.48"
					x2="916.33"
					y2="539.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="916.33"
					y1="539.46"
					x2="917.82"
					y2="539.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="917.82"
					y1="539.46"
					x2="917.82"
					y2="536.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="917.82"
					y1="536.48"
					x2="916.33"
					y2="536.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="916.33"
					y1="540.95"
					x2="922.29"
					y2="540.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="922.29"
					y1="540.95"
					x2="922.29"
					y2="539.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="922.29"
					y1="539.46"
					x2="916.33"
					y2="539.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="916.33"
					y1="539.46"
					x2="916.33"
					y2="540.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="747.91"
					y1="536.48"
					x2="747.91"
					y2="539.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="747.91"
					y1="539.46"
					x2="749.4"
					y2="539.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="749.4"
					y1="539.46"
					x2="749.4"
					y2="536.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="749.4"
					y1="536.48"
					x2="747.91"
					y2="536.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="749.4"
					y1="539.46"
					x2="743.44"
					y2="539.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="743.44"
					y1="539.46"
					x2="743.44"
					y2="540.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="743.44"
					y1="540.95"
					x2="749.4"
					y2="540.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="749.4"
					y1="540.95"
					x2="749.4"
					y2="539.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="916.33"
					y1="524.55"
					x2="922.29"
					y2="524.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="922.29"
					y1="524.55"
					x2="922.29"
					y2="520.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="922.29"
					y1="520.83"
					x2="916.33"
					y2="520.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="916.33"
					y1="520.83"
					x2="916.33"
					y2="524.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="749.4"
					y1="520.83"
					x2="743.44"
					y2="520.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="743.44"
					y1="520.83"
					x2="743.44"
					y2="524.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="743.44"
					y1="524.55"
					x2="749.4"
					y2="524.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="749.4"
					y1="524.55"
					x2="749.4"
					y2="520.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="911.86 536.48 917.82 536.48 917.82 524.55 911.86 524.55 911.86 536.48"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="747.91 536.48 753.88 536.48 753.88 524.55 747.91 524.55 747.91 536.48"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="835.85 524.55 753.88 524.55 753.88 529.77 835.85 529.77 835.85 524.55"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="876.09 529.77 794.12 529.77 794.12 534.99 876.09 534.99 876.09 529.77"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="917.82"
					y1="524.55"
					x2="918.56"
					y2="524.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="917.82"
					y1="536.48"
					x2="918.56"
					y2="536.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="918.56"
					y1="524.55"
					x2="918.56"
					y2="536.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="747.91"
					y1="524.55"
					x2="747.17"
					y2="524.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="747.91"
					y1="536.48"
					x2="747.17"
					y2="536.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="747.17"
					y1="524.55"
					x2="747.17"
					y2="536.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="911.86"
					y1="536.48"
					x2="911.86"
					y2="524.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="911.86"
					y1="524.55"
					x2="917.82"
					y2="524.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="917.82"
					y1="524.55"
					x2="917.82"
					y2="536.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="917.82"
					y1="536.48"
					x2="911.86"
					y2="536.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="747.91"
					y1="536.48"
					x2="747.91"
					y2="524.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="747.91"
					y1="524.55"
					x2="753.88"
					y2="524.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="753.88"
					y1="524.55"
					x2="753.88"
					y2="536.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="753.88"
					y1="536.48"
					x2="747.91"
					y2="536.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="835.85"
					y1="524.55"
					x2="835.85"
					y2="529.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="835.85"
					y1="529.77"
					x2="753.88"
					y2="529.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="753.88"
					y1="529.77"
					x2="753.88"
					y2="524.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="753.88"
					y1="524.55"
					x2="835.85"
					y2="524.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="876.09"
					y1="529.77"
					x2="876.09"
					y2="534.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="876.09"
					y1="534.99"
					x2="794.12"
					y2="534.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="794.12"
					y1="534.99"
					x2="794.12"
					y2="529.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="794.12"
					y1="529.77"
					x2="876.09"
					y2="529.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="918.56"
					y1="524.55"
					x2="918.56"
					y2="536.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="918.56"
					y1="524.55"
					x2="918.56"
					y2="536.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="918.56"
					y1="536.48"
					x2="918.56"
					y2="539.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="918.56"
					y1="524.55"
					x2="922.29"
					y2="524.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="918.56"
					y1="536.48"
					x2="918.56"
					y2="539.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="918.56"
					y1="539.46"
					x2="922.29"
					y2="539.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="918.56"
					y1="539.46"
					x2="922.29"
					y2="539.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="747.17"
					y1="524.55"
					x2="747.17"
					y2="536.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="747.17"
					y1="524.55"
					x2="747.17"
					y2="536.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="747.17"
					y1="536.48"
					x2="747.17"
					y2="539.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="747.17"
					y1="524.55"
					x2="743.44"
					y2="524.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="747.17"
					y1="536.48"
					x2="747.17"
					y2="539.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="747.17"
					y1="539.46"
					x2="743.44"
					y2="539.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="747.17"
					y1="539.46"
					x2="743.44"
					y2="539.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="220.44"
					y1="755.17"
					x2="220.44"
					y2="740.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="220.44"
					y1="740.26"
					x2="220.44"
					y2="470.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="220.44"
					y1="470.47"
					x2="205.54"
					y2="470.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="234.96"
					y1="65.22"
					x2="234.96"
					y2="89.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="469.41"
					y1="65.22"
					x2="469.41"
					y2="89.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<line
					x1="666.35"
					y1="89.06"
					x2="666.35"
					y2="65.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".39"
				/>
				<polyline
					points="888.27 910.94 888.27 810.29 706.87 810.29 706.87 910.94 888.27 910.94"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="706.87"
					y1="910.94"
					x2="888.27"
					y2="910.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="706.87"
					y1="810.29"
					x2="706.87"
					y2="910.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="888.27"
					y1="810.29"
					x2="706.87"
					y2="810.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="888.27"
					y1="910.94"
					x2="888.27"
					y2="810.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="712.74"
					y1="905.07"
					x2="882.4"
					y2="905.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="882.4"
					y1="905.07"
					x2="882.4"
					y2="816.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="882.4"
					y1="816.16"
					x2="712.74"
					y2="816.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="712.74"
					y1="816.16"
					x2="712.74"
					y2="905.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="712.74"
					y1="905.07"
					x2="789.14"
					y2="864.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="712.74"
					y1="816.16"
					x2="789.14"
					y2="856.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="882.4"
					y1="905.07"
					x2="806.01"
					y2="864.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="882.4"
					y1="816.16"
					x2="806.01"
					y2="856.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="797.57"
					y1="866.48"
					x2="797.57"
					y2="854.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="803.44"
					y1="860.61"
					x2="791.7"
					y2="860.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m806.96,860.61c0-5.18-4.21-9.39-9.39-9.39s-9.39,4.2-9.39,9.39,4.2,9.39,9.39,9.39,9.39-4.21,9.39-9.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m803.44,860.61c0-3.24-2.63-5.87-5.87-5.87s-5.87,2.63-5.87,5.87,2.63,5.87,5.87,5.87,5.87-2.63,5.87-5.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="888.27 860.61 875.82 869.78 875.82 851.45 888.27 860.61"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="888.27"
					y1="860.61"
					x2="875.82"
					y2="869.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="875.82"
					y1="869.78"
					x2="875.82"
					y2="851.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="875.82"
					y1="851.45"
					x2="888.27"
					y2="860.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="872.98"
					y1="860.61"
					x2="865.33"
					y2="860.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="875.82"
					y1="860.61"
					x2="875.82"
					y2="851.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="875.82"
					y1="851.45"
					x2="888.27"
					y2="860.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="875.82"
					y1="860.61"
					x2="875.82"
					y2="869.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="875.82"
					y1="869.78"
					x2="888.27"
					y2="860.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="873.22"
					y1="857.91"
					x2="866.58"
					y2="854.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="873.22"
					y1="863.32"
					x2="866.58"
					y2="867.12"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="832.93 666.37 830.56 671.69 829.74 677.45 830.56 683.22 832.93 688.54 835.95 692.05 839.73 694.7 848.6 698.08 859.7 699.25 870.58 696.76 880.37 697.58 889.29 701.66 891.81 703.26 896.99 705.15 902.5 704.86 904.67 704.01 910.46 704.01 910.46 701.6 907.82 701.6 910.26 697.56 911.21 692.93 911.21 661.97 909.6 655.99 905.34 651.49 899.45 649.56 898.73 649.56 895.01 650.18 889.15 653.32 880.33 657.37 870.66 658.17 859.74 655.66 848.6 656.83 839.73 660.2 835.95 662.86 832.93 666.37"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="883.69"
					y1="688.49"
					x2="883.69"
					y2="666.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="911.21"
					y1="661.97"
					x2="911.21"
					y2="677.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="910.1"
					y1="661.97"
					x2="910.1"
					y2="677.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="911.21"
					y1="692.93"
					x2="911.21"
					y2="677.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="910.1"
					y1="692.93"
					x2="910.1"
					y2="677.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="883.69"
					y1="666.99"
					x2="887.81"
					y2="666.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="887.81"
					y1="666.99"
					x2="887.81"
					y2="670.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="887.81"
					y1="670.4"
					x2="883.69"
					y2="670.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="883.69"
					y1="687.91"
					x2="887.81"
					y2="687.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="887.81"
					y1="687.91"
					x2="887.81"
					y2="684.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="887.81"
					y1="684.5"
					x2="883.69"
					y2="684.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="900.21"
					y1="701.6"
					x2="910.46"
					y2="701.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="900.21"
					y1="704.01"
					x2="910.46"
					y2="704.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="910.46"
					y1="704.01"
					x2="910.46"
					y2="701.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="900.21"
					y1="704.01"
					x2="900.21"
					y2="701.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="829.74"
					y1="677.45"
					x2="830.16"
					y2="673.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="830.16"
					y1="673.75"
					x2="831.12"
					y2="670.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="831.12"
					y1="670.18"
					x2="832.93"
					y2="666.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="832.93"
					y1="666.37"
					x2="835.94"
					y2="662.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="835.94"
					y1="662.86"
					x2="839.73"
					y2="660.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="839.73"
					y1="660.2"
					x2="844.03"
					y2="658.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="844.03"
					y1="658.25"
					x2="848.6"
					y2="656.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="848.6"
					y1="656.83"
					x2="852.27"
					y2="656.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="852.27"
					y1="656.02"
					x2="855.98"
					y2="655.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="855.98"
					y1="655.54"
					x2="859.7"
					y2="655.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="859.7"
					y1="655.47"
					x2="863.41"
					y2="655.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="863.41"
					y1="655.89"
					x2="869.17"
					y2="657.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="869.17"
					y1="657.56"
					x2="874.73"
					y2="660.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="874.73"
					y1="660.17"
					x2="879.71"
					y2="663.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="879.71"
					y1="663.27"
					x2="883.69"
					y2="666.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="870.66"
					y1="658.17"
					x2="875.83"
					y2="658.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="875.83"
					y1="658.14"
					x2="880.85"
					y2="657.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="880.85"
					y1="657.29"
					x2="883.56"
					y2="656.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="883.56"
					y1="656.42"
					x2="886.24"
					y2="655.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="886.24"
					y1="655.16"
					x2="890.15"
					y2="652.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="890.15"
					y1="652.66"
					x2="894.19"
					y2="650.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="894.19"
					y1="650.47"
					x2="898.13"
					y2="649.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="898.13"
					y1="649.59"
					x2="902.07"
					y2="649.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="902.07"
					y1="649.93"
					x2="905.64"
					y2="651.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="905.64"
					y1="651.46"
					x2="907.19"
					y2="652.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="907.19"
					y1="652.66"
					x2="908.52"
					y2="654.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="908.52"
					y1="654.16"
					x2="909.98"
					y2="656.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="909.98"
					y1="656.8"
					x2="910.79"
					y2="659.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="910.79"
					y1="659.33"
					x2="911.21"
					y2="661.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="910.1"
					y1="661.97"
					x2="909.98"
					y2="660.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="909.98"
					y1="660.79"
					x2="909.23"
					y2="658.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="909.23"
					y1="658.36"
					x2="907.41"
					y2="656.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="907.41"
					y1="656.2"
					x2="904.89"
					y2="654.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="904.89"
					y1="654.86"
					x2="901.57"
					y2="654.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="901.57"
					y1="654.22"
					x2="898.14"
					y2="654.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="898.14"
					y1="654.07"
					x2="896.44"
					y2="654.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="896.44"
					y1="654.09"
					x2="895.09"
					y2="654.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="895.09"
					y1="654.81"
					x2="894.7"
					y2="655.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="894.7"
					y1="655.65"
					x2="892.04"
					y2="665.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="892.04"
					y1="665.01"
					x2="891.24"
					y2="669.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="891.24"
					y1="669.67"
					x2="890.9"
					y2="674.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="890.9"
					y1="674.38"
					x2="890.9"
					y2="677.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="870.58"
					y1="696.76"
					x2="875.76"
					y2="696.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="875.76"
					y1="696.8"
					x2="880.82"
					y2="697.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="880.82"
					y1="697.65"
					x2="883.54"
					y2="698.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="883.54"
					y1="698.51"
					x2="886.24"
					y2="699.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="886.24"
					y1="699.75"
					x2="890.16"
					y2="702.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="890.16"
					y1="702.23"
					x2="894.19"
					y2="704.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="894.19"
					y1="704.44"
					x2="896.82"
					y2="705.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="896.82"
					y1="705.16"
					x2="899.53"
					y2="705.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="899.53"
					y1="705.33"
					x2="902.19"
					y2="704.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="902.19"
					y1="704.95"
					x2="904.67"
					y2="704.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="910.1"
					y1="692.93"
					x2="909.98"
					y2="694.12"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="909.98"
					y1="694.12"
					x2="909.23"
					y2="696.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="909.23"
					y1="696.55"
					x2="907.41"
					y2="698.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="907.41"
					y1="698.7"
					x2="904.89"
					y2="700.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="904.89"
					y1="700.05"
					x2="901.57"
					y2="700.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="901.57"
					y1="700.69"
					x2="898.14"
					y2="700.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="898.14"
					y1="700.84"
					x2="896.44"
					y2="700.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="896.44"
					y1="700.82"
					x2="895.09"
					y2="700.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="895.09"
					y1="700.1"
					x2="894.7"
					y2="699.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="894.7"
					y1="699.26"
					x2="892.04"
					y2="689.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="892.04"
					y1="689.89"
					x2="891.24"
					y2="685.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="891.24"
					y1="685.24"
					x2="890.9"
					y2="680.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="890.9"
					y1="680.53"
					x2="890.9"
					y2="677.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="829.74"
					y1="677.45"
					x2="830.16"
					y2="681.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="830.16"
					y1="681.15"
					x2="831.12"
					y2="684.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="831.12"
					y1="684.73"
					x2="832.93"
					y2="688.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="832.93"
					y1="688.54"
					x2="835.94"
					y2="692.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="835.94"
					y1="692.05"
					x2="839.73"
					y2="694.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="839.73"
					y1="694.7"
					x2="844.03"
					y2="696.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="844.03"
					y1="696.66"
					x2="848.6"
					y2="698.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="848.6"
					y1="698.08"
					x2="852.27"
					y2="698.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="852.27"
					y1="698.89"
					x2="855.98"
					y2="699.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="855.98"
					y1="699.37"
					x2="859.7"
					y2="699.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="859.7"
					y1="699.44"
					x2="863.41"
					y2="699.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="863.41"
					y1="699.02"
					x2="869.17"
					y2="697.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="869.17"
					y1="697.34"
					x2="874.73"
					y2="694.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="874.73"
					y1="694.73"
					x2="879.71"
					y2="691.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="879.71"
					y1="691.63"
					x2="883.69"
					y2="688.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="892.04"
					y1="651.51"
					x2="891.2"
					y2="652.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="891.2"
					y1="652.1"
					x2="889.94"
					y2="653.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="889.94"
					y1="653.8"
					x2="889.65"
					y2="655.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="889.65"
					y1="655.28"
					x2="888.84"
					y2="664.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="888.84"
					y1="664.79"
					x2="888.46"
					y2="674.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="888.46"
					y1="674.33"
					x2="888.46"
					y2="677.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="892.04"
					y1="703.4"
					x2="891.2"
					y2="702.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="891.2"
					y1="702.81"
					x2="889.94"
					y2="701.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="889.94"
					y1="701.1"
					x2="889.65"
					y2="699.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="889.65"
					y1="699.63"
					x2="888.84"
					y2="690.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="888.84"
					y1="690.11"
					x2="888.46"
					y2="680.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="888.46"
					y1="680.58"
					x2="888.46"
					y2="677.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="907.82"
					y1="701.6"
					x2="908.52"
					y2="700.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="908.52"
					y1="700.74"
					x2="909.98"
					y2="698.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="909.98"
					y1="698.1"
					x2="910.79"
					y2="695.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="910.79"
					y1="695.58"
					x2="911.21"
					y2="692.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="911.21 641.68 910.02 641.68 910.02 647.65 911.21 647.65 911.21 641.68"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="911.21"
					y1="647.65"
					x2="911.21"
					y2="641.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="910.02"
					y1="647.65"
					x2="911.21"
					y2="647.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="910.02"
					y1="641.68"
					x2="910.02"
					y2="647.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="911.21"
					y1="641.68"
					x2="910.02"
					y2="641.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="911.21 713.22 911.21 707.26 910.02 707.26 910.02 713.22 911.21 713.22"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="910.02"
					y1="713.22"
					x2="911.21"
					y2="713.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="910.02"
					y1="707.26"
					x2="910.02"
					y2="713.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="911.21"
					y1="707.26"
					x2="910.02"
					y2="707.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="911.21"
					y1="713.22"
					x2="911.21"
					y2="707.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="910.02 644.07 900.32 644.07 900.32 645.26 910.02 645.26 910.02 644.07"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="910.02"
					y1="645.26"
					x2="910.02"
					y2="644.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="900.32"
					y1="645.26"
					x2="910.02"
					y2="645.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="900.32"
					y1="644.07"
					x2="900.32"
					y2="645.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="910.02"
					y1="644.07"
					x2="900.32"
					y2="644.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="910.02 710.84 910.02 709.65 900.32 709.65 900.32 710.84 910.02 710.84"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="900.32"
					y1="710.84"
					x2="910.02"
					y2="710.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="900.32"
					y1="709.65"
					x2="900.32"
					y2="710.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="910.02"
					y1="709.65"
					x2="900.32"
					y2="709.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="910.02"
					y1="710.84"
					x2="910.02"
					y2="709.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="903.3 645.26 900.92 645.26 900.92 709.65 903.3 709.65 903.3 645.26"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="903.3"
					y1="709.65"
					x2="903.3"
					y2="645.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="900.92"
					y1="709.65"
					x2="903.3"
					y2="709.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="900.92"
					y1="645.26"
					x2="900.92"
					y2="709.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="903.3"
					y1="645.26"
					x2="900.92"
					y2="645.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="851.62 805.21 911.21 805.21 911.21 730.51 851.62 730.51 851.62 805.21"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="851.62"
					y1="805.21"
					x2="851.62"
					y2="730.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="911.21"
					y1="805.21"
					x2="911.21"
					y2="730.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="851.62"
					y1="730.51"
					x2="911.21"
					y2="730.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="851.62"
					y1="805.21"
					x2="911.21"
					y2="805.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="908.87"
					y1="805.21"
					x2="908.87"
					y2="730.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="865.77"
					y1="797.66"
					x2="865.77"
					y2="738.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="865.77"
					y1="738.05"
					x2="901.54"
					y2="738.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="901.54"
					y1="738.05"
					x2="901.54"
					y2="797.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="901.54"
					y1="797.66"
					x2="865.77"
					y2="797.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="863.42"
					y1="800.01"
					x2="863.42"
					y2="735.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="863.42"
					y1="735.7"
					x2="903.88"
					y2="735.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="903.88"
					y1="735.7"
					x2="903.88"
					y2="800.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="903.88"
					y1="800.01"
					x2="863.42"
					y2="800.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m896.98,767.86c0-1.95-1.58-3.52-3.52-3.52s-3.52,1.58-3.52,3.52,1.58,3.52,3.52,3.52,3.52-1.58,3.52-3.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="907.99 770.79 903.07 770.32 901.95 769.94 895.74 769.16 894.92 768.72 894.59 767.86 894.92 766.99 895.74 766.55 901.95 765.78 903.07 765.39 907.99 764.92 909.72 765.48 910.78 766.95 910.78 768.76 909.72 770.23 907.99 770.79"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="907.99"
					y1="770.79"
					x2="903.07"
					y2="770.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m903.07,770.32c-.4-.03-.78-.17-1.11-.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="901.95"
					y1="769.94"
					x2="895.74"
					y2="769.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m895.74,769.16c-.66-.08-1.15-.64-1.15-1.3s.49-1.22,1.15-1.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="895.74"
					y1="766.55"
					x2="901.95"
					y2="765.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m901.95,765.78c.33-.22.72-.35,1.11-.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="903.07"
					y1="765.39"
					x2="907.99"
					y2="764.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m907.99,764.92c1.62,0,2.94,1.31,2.94,2.94s-1.32,2.93-2.94,2.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="905.07"
					y1="766.26"
					x2="903.32"
					y2="766.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="903.32"
					y1="769.45"
					x2="905.07"
					y2="769.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="905.07"
					y1="769.45"
					x2="905.07"
					y2="766.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m903.32,769.45c-.88,0-1.6-.71-1.6-1.6s.71-1.6,1.6-1.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m901.95,769.94c-.71-.45-1.13-1.24-1.13-2.08s.43-1.63,1.13-2.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="306.56"
					y1="755.17"
					x2="197.45"
					y2="755.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="306.56"
					y1="853.75"
					x2="306.56"
					y2="755.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="299.11"
					y1="853.75"
					x2="299.11"
					y2="755.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="291.98 540.87 223.97 540.87 223.97 474.03 291.98 474.03 291.98 540.87"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="291.98"
					y1="540.87"
					x2="288.74"
					y2="540.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="284.44"
					y1="540.87"
					x2="277.29"
					y2="540.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="273"
					y1="540.87"
					x2="265.84"
					y2="540.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="261.55"
					y1="540.87"
					x2="254.4"
					y2="540.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="250.1"
					y1="540.87"
					x2="242.95"
					y2="540.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="238.66"
					y1="540.87"
					x2="231.5"
					y2="540.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="227.21"
					y1="540.87"
					x2="223.97"
					y2="540.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="223.97"
					y1="540.87"
					x2="223.97"
					y2="538.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="223.97"
					y1="533.92"
					x2="223.97"
					y2="526.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="223.97"
					y1="522.47"
					x2="223.97"
					y2="515.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="223.97"
					y1="511.03"
					x2="223.97"
					y2="503.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="223.97"
					y1="499.58"
					x2="223.97"
					y2="492.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="223.97"
					y1="488.14"
					x2="223.97"
					y2="480.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="223.97"
					y1="476.69"
					x2="223.97"
					y2="474.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="223.97"
					y1="474.03"
					x2="227.21"
					y2="474.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="231.5"
					y1="474.03"
					x2="238.66"
					y2="474.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="242.95"
					y1="474.03"
					x2="250.1"
					y2="474.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="254.4"
					y1="474.03"
					x2="261.55"
					y2="474.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="265.84"
					y1="474.03"
					x2="273"
					y2="474.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="277.29"
					y1="474.03"
					x2="284.44"
					y2="474.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="288.74"
					y1="474.03"
					x2="291.98"
					y2="474.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="291.98"
					y1="474.03"
					x2="291.98"
					y2="476.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="291.98"
					y1="480.98"
					x2="291.98"
					y2="488.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="291.98"
					y1="492.43"
					x2="291.98"
					y2="499.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="291.98"
					y1="503.88"
					x2="291.98"
					y2="511.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="291.98"
					y1="515.32"
					x2="291.98"
					y2="522.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="291.98"
					y1="526.76"
					x2="291.98"
					y2="533.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="291.98"
					y1="538.21"
					x2="291.98"
					y2="540.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="295.5 474.28 297.56 474.28 297.56 540.62 295.5 540.62 295.5 530.21 297.19 530.21 297.19 484.69 295.5 484.69 295.5 474.28"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="295.5"
					y1="474.28"
					x2="297.56"
					y2="474.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".28"
				/>
				<line
					x1="297.56"
					y1="474.28"
					x2="297.56"
					y2="540.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".28"
				/>
				<line
					x1="297.56"
					y1="540.62"
					x2="295.5"
					y2="540.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".28"
				/>
				<line
					x1="295.5"
					y1="540.62"
					x2="295.5"
					y2="530.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".28"
				/>
				<line
					x1="295.5"
					y1="530.21"
					x2="297.19"
					y2="530.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".28"
				/>
				<line
					x1="297.19"
					y1="530.21"
					x2="297.19"
					y2="484.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".28"
				/>
				<line
					x1="297.19"
					y1="484.69"
					x2="295.5"
					y2="484.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".28"
				/>
				<line
					x1="295.5"
					y1="484.69"
					x2="295.5"
					y2="474.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".28"
				/>
				<polyline
					points="295.5 471.68 295.5 543.22 291.98 543.22 291.98 471.68 295.5 471.68"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="295.5"
					y1="471.68"
					x2="295.5"
					y2="543.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".28"
				/>
				<line
					x1="295.5"
					y1="543.22"
					x2="291.98"
					y2="543.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".28"
				/>
				<line
					x1="291.98"
					y1="543.22"
					x2="291.98"
					y2="471.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".28"
				/>
				<line
					x1="291.98"
					y1="471.68"
					x2="295.5"
					y2="471.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".28"
				/>
				<line
					x1="295.5"
					y1="540.62"
					x2="297.56"
					y2="540.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="297.56"
					y1="540.62"
					x2="297.56"
					y2="474.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="297.56"
					y1="474.28"
					x2="295.5"
					y2="474.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="295.5"
					y1="543.22"
					x2="295.5"
					y2="471.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="295.5"
					y1="484.69"
					x2="297.19"
					y2="484.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="297.19"
					y1="484.69"
					x2="297.19"
					y2="530.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="297.19"
					y1="530.21"
					x2="295.5"
					y2="530.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="291.98"
					y1="543.22"
					x2="295.5"
					y2="543.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="295.5"
					y1="471.68"
					x2="291.98"
					y2="471.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="291.98"
					y1="471.68"
					x2="291.98"
					y2="543.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="297.94 639.21 220.44 639.21 220.44 728.63 297.94 728.63 297.94 639.21"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="297.94"
					y1="639.21"
					x2="297.94"
					y2="728.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="220.44"
					y1="639.21"
					x2="220.44"
					y2="728.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="222.79"
					y1="639.21"
					x2="222.79"
					y2="728.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="297.94"
					y1="639.21"
					x2="220.44"
					y2="639.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="297.94"
					y1="728.63"
					x2="220.44"
					y2="728.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="294.42"
					y1="645.07"
					x2="294.42"
					y2="722.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="294.42"
					y1="722.76"
					x2="292.07"
					y2="725.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="292.07"
					y1="725.11"
					x2="226.31"
					y2="725.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="226.31"
					y1="725.11"
					x2="223.97"
					y2="722.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="223.97"
					y1="722.76"
					x2="223.97"
					y2="645.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="223.97"
					y1="645.07"
					x2="226.31"
					y2="642.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="226.31"
					y1="642.73"
					x2="292.07"
					y2="642.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="292.07"
					y1="642.73"
					x2="294.42"
					y2="645.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m290.3,661.56c0-6.48-5.25-11.74-11.74-11.74s-11.74,5.25-11.74,11.74,5.25,11.74,11.74,11.74,11.74-5.25,11.74-11.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m248.62,661.56c0-4.86-3.94-8.8-8.8-8.8s-8.8,3.94-8.8,8.8,3.94,8.8,8.8,8.8,8.8-3.94,8.8-8.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m287.37,706.27c0-4.86-3.94-8.8-8.8-8.8s-8.8,3.94-8.8,8.8,3.94,8.8,8.8,8.8,8.8-3.94,8.8-8.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m251.55,706.27c0-6.48-5.25-11.74-11.74-11.74s-11.74,5.25-11.74,11.74,5.25,11.74,11.74,11.74,11.74-5.25,11.74-11.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="283.41 553.27 283.41 627.51 283.1 628.68 282.24 629.54 281.07 629.86 231.36 629.86 230.19 629.54 229.33 628.68 229.01 627.51 229.01 553.27 229.33 552.09 230.19 551.23 231.36 550.92 281.07 550.92 282.24 551.23 283.1 552.09 283.41 553.27"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="283.41"
					y1="553.27"
					x2="283.41"
					y2="627.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m283.41,627.51c0,1.29-1.05,2.35-2.35,2.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="281.07"
					y1="629.86"
					x2="231.36"
					y2="629.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m231.36,629.86c-1.3,0-2.35-1.05-2.35-2.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="229.01"
					y1="627.51"
					x2="229.01"
					y2="553.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m229.01,553.27c0-1.29,1.05-2.35,2.35-2.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="231.36"
					y1="550.92"
					x2="281.07"
					y2="550.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m281.07,550.92c1.29,0,2.35,1.05,2.35,2.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="277.55"
					y1="559.13"
					x2="277.55"
					y2="621.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="275.2"
					y1="623.99"
					x2="243.1"
					y2="623.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="240.75"
					y1="621.64"
					x2="240.75"
					y2="559.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="243.1"
					y1="556.79"
					x2="275.2"
					y2="556.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="277.55"
					y1="559.13"
					x2="277.55"
					y2="559.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m277.55,621.64c0,1.3-1.05,2.35-2.35,2.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m243.1,623.99c-1.3,0-2.35-1.05-2.35-2.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m240.75,559.13c0-1.3,1.05-2.35,2.35-2.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m275.2,556.79c1.29,0,2.35,1.05,2.35,2.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m256.01,590.39c0-1.95-1.58-3.52-3.52-3.52s-3.52,1.58-3.52,3.52,1.58,3.52,3.52,3.52,3.52-1.58,3.52-3.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="255.76 589.33 256.5 589.64 256.81 590.39 256.5 591.14 255.75 591.44 232.53 591.44 231.79 591.13 231.48 590.39 231.79 589.64 232.53 589.33 255.76 589.33"
					fill="none"
					fillRule="evenodd"
				/>
				<path
					d="m255.76,589.33c.58,0,1.05.47,1.05,1.06s-.47,1.06-1.06,1.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="255.75"
					y1="591.44"
					x2="232.53"
					y2="591.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m232.53,591.44c-.58,0-1.06-.47-1.06-1.06s.47-1.06,1.06-1.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="232.53"
					y1="589.33"
					x2="255.76"
					y2="589.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="238.52 588.05 238.52 589.33 232.53 589.33 231.79 589.64 231.48 590.39 231.79 591.13 232.53 591.44 238.52 591.44 238.52 592.73 230.89 592.73 230.89 588.05 238.52 588.05"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="238.52"
					y1="588.05"
					x2="238.52"
					y2="589.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="238.52"
					y1="589.33"
					x2="232.53"
					y2="589.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m232.53,591.44c-.58,0-1.06-.47-1.06-1.06s.47-1.06,1.06-1.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="232.53"
					y1="591.44"
					x2="238.52"
					y2="591.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="238.52"
					y1="591.44"
					x2="238.52"
					y2="592.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="238.52"
					y1="592.73"
					x2="230.89"
					y2="592.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="230.89"
					y1="592.73"
					x2="230.89"
					y2="588.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="230.89"
					y1="588.05"
					x2="238.52"
					y2="588.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="242.74 588.08 242.74 589.33 238.64 589.33 238.64 588.08 242.74 588.08"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="242.74"
					y1="588.08"
					x2="242.74"
					y2="589.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="242.74"
					y1="589.33"
					x2="238.64"
					y2="589.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="238.64"
					y1="589.33"
					x2="238.64"
					y2="588.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="238.64"
					y1="588.08"
					x2="242.74"
					y2="588.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="242.74 592.7 238.64 592.7 238.64 591.44 242.74 591.44 242.74 592.7"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="242.74"
					y1="592.7"
					x2="238.64"
					y2="592.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="238.64"
					y1="592.7"
					x2="238.64"
					y2="591.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="238.64"
					y1="591.44"
					x2="242.74"
					y2="591.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="242.74"
					y1="591.44"
					x2="242.74"
					y2="592.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="636.53"
					y1="850.6"
					x2="636.53"
					y2="829.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="636.53"
					y1="829.74"
					x2="579.9"
					y2="829.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="648.46"
					y1="850.6"
					x2="567.98"
					y2="850.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="567.98"
					y1="904.26"
					x2="648.46"
					y2="904.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="648.46"
					y1="904.26"
					x2="648.46"
					y2="823.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="567.98"
					y1="823.78"
					x2="567.98"
					y2="904.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="648.46"
					y1="825.27"
					x2="567.98"
					y2="825.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="579.9"
					y1="850.6"
					x2="579.9"
					y2="829.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="648.46"
					y1="823.78"
					x2="567.98"
					y2="823.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="306.56"
					y1="758.15"
					x2="312.45"
					y2="758.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="312.45"
					y1="758.15"
					x2="312.45"
					y2="761.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="312.45"
					y1="761.13"
					x2="306.56"
					y2="761.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="291.98"
					y1="853.75"
					x2="291.98"
					y2="846.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="291.98"
					y1="842.37"
					x2="291.98"
					y2="835.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="291.98"
					y1="830.93"
					x2="291.98"
					y2="823.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="291.98"
					y1="819.48"
					x2="291.98"
					y2="812.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="291.98"
					y1="808.04"
					x2="291.98"
					y2="800.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="291.98"
					y1="796.59"
					x2="291.98"
					y2="789.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="291.98"
					y1="785.14"
					x2="291.98"
					y2="777.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="291.98"
					y1="773.7"
					x2="291.98"
					y2="766.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="291.98"
					y1="762.25"
					x2="291.98"
					y2="755.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="256.22"
					y1="755.17"
					x2="256.22"
					y2="752.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="256.22"
					y1="748.03"
					x2="256.22"
					y2="740.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="256.22"
					y1="736.58"
					x2="256.22"
					y2="729.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="256.22"
					y1="725.14"
					x2="256.22"
					y2="717.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="256.22"
					y1="713.69"
					x2="256.22"
					y2="706.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="256.22"
					y1="702.24"
					x2="256.22"
					y2="695.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="256.22"
					y1="690.8"
					x2="256.22"
					y2="683.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="256.22"
					y1="679.35"
					x2="256.22"
					y2="672.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="256.22"
					y1="667.91"
					x2="256.22"
					y2="660.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="256.22"
					y1="656.46"
					x2="256.22"
					y2="649.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="256.22"
					y1="645.01"
					x2="256.22"
					y2="637.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="256.22"
					y1="633.57"
					x2="256.22"
					y2="626.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="256.22"
					y1="622.12"
					x2="256.22"
					y2="614.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="256.22"
					y1="610.67"
					x2="256.22"
					y2="603.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="256.22"
					y1="599.23"
					x2="256.22"
					y2="592.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="256.22"
					y1="587.78"
					x2="256.22"
					y2="580.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="256.22"
					y1="576.34"
					x2="256.22"
					y2="569.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="256.22"
					y1="564.89"
					x2="256.22"
					y2="557.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="256.22"
					y1="553.44"
					x2="256.22"
					y2="546.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="256.22"
					y1="542"
					x2="256.22"
					y2="534.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="256.22"
					y1="530.55"
					x2="256.22"
					y2="523.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="256.22"
					y1="519.11"
					x2="256.22"
					y2="511.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="256.22"
					y1="507.66"
					x2="256.22"
					y2="500.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="256.22"
					y1="496.21"
					x2="256.22"
					y2="489.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="256.22"
					y1="484.77"
					x2="256.22"
					y2="477.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="256.22"
					y1="473.32"
					x2="256.22"
					y2="470.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="291.98"
					y1="755.17"
					x2="291.98"
					y2="728.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="291.98"
					y1="470.47"
					x2="220.44"
					y2="470.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="291.98"
					y1="639.21"
					x2="291.98"
					y2="470.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="234.96"
					y1="89.06"
					x2="469.41"
					y2="89.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="666.35"
					y1="65.22"
					x2="847.57"
					y2="65.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="234.96"
					y1="65.22"
					x2="469.41"
					y2="65.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="666.35"
					y1="89.06"
					x2="847.57"
					y2="89.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="636.53"
					y1="895.31"
					x2="579.9"
					y2="895.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="579.9"
					y1="895.31"
					x2="579.9"
					y2="856.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="579.9"
					y1="856.56"
					x2="636.53"
					y2="856.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="636.53"
					y1="856.56"
					x2="636.53"
					y2="895.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
			</g>
			<g id="walls">
				<polygon
					points="413.71 853.74 413.71 877.59 159.4 877.59 159.4 494.32 50 494.32 50 65.21 234.97 65.21 234.97 89.06 159.71 89.06 159.71 119.01 73.85 119.01 73.85 470.47 220.45 470.47 220.45 755.16 197.45 755.16 197.45 853.74 413.71 853.74"
					fill="none"
					fillRule="evenodd"
					stroke="#000"
					strokeMiterlimit="10"
					strokeWidth="1.42"
				/>
				<polygon
					points="950 65.21 950 638.61 935.06 638.61 935.06 934.79 531.46 934.79 531.46 877.59 526.98 877.59 526.98 853.74 540.4 853.74 540.4 800.42 560.52 800.42 560.52 815.32 555.3 815.32 555.3 910.94 661.13 910.94 661.13 815.32 655.92 815.32 655.92 800.42 691.96 800.42 691.96 741.2 706.88 741.2 706.88 910.94 888.27 910.94 888.27 805.2 911.21 805.2 911.21 629.67 706.88 629.67 706.88 645.82 691.96 645.82 691.96 629.67 669.17 629.67 669.17 614.77 724.67 614.77 724.67 524.55 747.17 524.55 747.17 539.46 739.57 539.46 739.57 614.77 926.16 614.77 926.16 539.46 918.57 539.46 918.57 524.55 926.16 524.55 926.16 89.06 847.57 89.06 847.57 65.21 950 65.21"
					fill="none"
					fillRule="evenodd"
					stroke="#000"
					strokeMiterlimit="10"
					strokeWidth="1.42"
				/>
				<polygon
					points="666.35 65.21 666.35 89.06 633.34 89.06 633.34 184.12 568.51 184.12 568.51 614.77 573.79 614.77 573.79 629.67 553.6 629.67 553.6 89.06 469.41 89.06 469.41 65.21 666.35 65.21"
					fill="none"
					fillRule="evenodd"
					stroke="#000"
					strokeMiterlimit="10"
					strokeWidth="1.42"
				/>
			</g>
			<g id="text">
				<path d="m247.64,812.74h-1.94l-2.33-3.9c-.21-.36-.42-.67-.62-.92-.2-.26-.41-.47-.62-.63-.21-.16-.43-.28-.68-.35-.24-.08-.51-.12-.82-.12h-1.34v5.92h-1.63v-13.92h4.15c.61,0,1.17.08,1.68.23.52.15.96.38,1.34.69.38.31.68.7.89,1.16.21.46.32,1,.32,1.62,0,.49-.07.93-.22,1.34-.14.4-.35.76-.62,1.08-.27.32-.59.59-.97.82-.38.22-.8.39-1.27.51v.04c.23.1.43.22.6.36.17.13.34.28.5.47.16.18.31.39.46.62.16.23.33.49.51.8l2.61,4.18Zm-8.35-12.44v5.05h2.21c.41,0,.78-.06,1.13-.18.35-.12.65-.3.9-.52.25-.23.45-.51.59-.84.14-.34.21-.71.21-1.13,0-.74-.24-1.32-.73-1.74-.48-.42-1.17-.63-2.09-.63h-2.23Zm17.85,7.87h-7.02c.03,1.11.32,1.96.89,2.56.57.6,1.35.9,2.35.9,1.12,0,2.15-.37,3.09-1.11v1.49c-.87.63-2.03.95-3.47.95s-2.51-.45-3.31-1.35c-.8-.91-1.2-2.18-1.2-3.81,0-1.55.44-2.81,1.31-3.78.88-.98,1.97-1.47,3.27-1.47s2.31.42,3.02,1.26c.71.84,1.07,2.01,1.07,3.5v.83Zm-1.63-1.35c0-.92-.23-1.63-.67-2.15-.43-.51-1.04-.77-1.82-.77s-1.39.27-1.91.81-.85,1.24-.97,2.11h5.37Zm8.77-7.4c-.31-.17-.66-.26-1.06-.26-1.11,0-1.67.7-1.67,2.11v1.53h2.33v1.36h-2.33v8.58h-1.58v-8.58h-1.7v-1.36h1.7v-1.61c0-1.04.3-1.86.9-2.47.6-.61,1.35-.91,2.25-.91.49,0,.87.06,1.16.17v1.44Z" />
				<path d="m265.97,812.96c-.3,0-.55-.11-.77-.32-.21-.21-.31-.47-.31-.77s.1-.55.31-.77c.21-.22.47-.33.77-.33s.56.11.78.33c.21.21.32.47.32.77s-.11.55-.32.77-.47.32-.78.32Z" />
				<path d="m225.54,513.69v-13.83h4.76c1.08,0,1.9.07,2.46.2.79.18,1.47.51,2.03.99.73.62,1.27,1.41,1.63,2.37.36.96.55,2.05.55,3.28,0,1.05-.12,1.98-.37,2.79-.25.81-.56,1.48-.94,2.02-.38.53-.8.95-1.26,1.25-.45.3-1,.53-1.65.69-.64.16-1.38.24-2.22.24h-4.99Zm1.83-1.63h2.95c.91,0,1.63-.08,2.14-.25.52-.17.94-.41,1.24-.72.43-.43.77-1.02,1.01-1.74.25-.74.37-1.63.37-2.67,0-1.45-.24-2.56-.72-3.33-.47-.78-1.05-1.3-1.73-1.57-.49-.19-1.28-.28-2.37-.28h-2.9v10.56Zm14.54,1.63l-3.67-13.83h1.88l2.1,9.06c.23.95.42,1.89.58,2.83.35-1.48.56-2.33.62-2.56l2.63-9.34h2.21l1.98,7c.5,1.74.86,3.37,1.08,4.9.18-.87.41-1.88.69-3.01l2.17-8.88h1.84l-3.79,13.83h-1.76l-2.91-10.53c-.25-.88-.39-1.42-.43-1.62-.14.64-.28,1.18-.41,1.62l-2.93,10.53h-1.87Z" />
				<path d="m192.7,277.66h-11.21v-21.6h2.53v19.31h8.68v2.29Zm4.25-19.34c-.44,0-.82-.15-1.13-.45-.31-.3-.47-.68-.47-1.14s.16-.84.47-1.15c.31-.31.69-.47,1.13-.47s.83.16,1.15.47c.32.3.48.68.48,1.15s-.16.82-.48,1.13c-.31.31-.69.47-1.15.47Zm1.21,19.34h-2.47v-15.43h2.47v15.43Zm17.11-15.43l-6.15,15.43h-2.43l-5.85-15.43h2.71l3.92,11.21c.29.82.47,1.54.54,2.15h.06c.1-.77.26-1.47.48-2.09l4.1-11.27h2.61Zm3.91-3.92c-.44,0-.82-.15-1.13-.45-.31-.3-.47-.68-.47-1.14s.16-.84.47-1.15c.31-.31.69-.47,1.13-.47s.83.16,1.14.47c.32.3.48.68.48,1.15s-.16.82-.48,1.13c-.31.31-.69.47-1.14.47Zm1.21,19.34h-2.47v-15.43h2.47v15.43Zm17.79,0h-2.47v-8.8c0-3.27-1.2-4.91-3.59-4.91-1.24,0-2.26.47-3.07,1.4-.8.92-1.21,2.09-1.21,3.51v8.8h-2.47v-15.43h2.47v2.56h.06c1.17-1.95,2.85-2.92,5.06-2.92,1.69,0,2.98.55,3.87,1.64.89,1.08,1.34,2.66,1.34,4.72v9.43Zm17.82-1.24c0,5.66-2.71,8.5-8.14,8.5-1.91,0-3.58-.36-5-1.08v-2.47c1.74.96,3.39,1.45,4.97,1.45,3.8,0,5.69-2.02,5.69-6.06v-1.69h-.06c-1.18,1.97-2.94,2.95-5.3,2.95-1.92,0-3.47-.68-4.64-2.05-1.17-1.38-1.75-3.22-1.75-5.53,0-2.62.63-4.71,1.88-6.25,1.27-1.55,2.99-2.32,5.18-2.32s3.62.83,4.63,2.5h.06v-2.14h2.47v14.19Zm-2.47-5.74v-2.27c0-1.23-.42-2.27-1.25-3.15-.82-.87-1.85-1.31-3.09-1.31-1.53,0-2.72.56-3.59,1.67-.86,1.1-1.3,2.66-1.3,4.66,0,1.72.41,3.09,1.24,4.13.83,1.02,1.93,1.54,3.3,1.54s2.51-.49,3.37-1.48c.87-.98,1.31-2.24,1.31-3.78Z" />
				<polygon points="270.73 256.06 260.37 281.25 258.06 281.25 268.4 256.06 270.73 256.06" />
				<path d="m273.25,277.66v-21.6h5.97c7.61,0,11.42,3.51,11.42,10.53,0,3.33-1.06,6.02-3.18,8.05-2.11,2.02-4.94,3.03-8.48,3.03h-5.73Zm2.53-19.31v17.02h3.22c2.83,0,5.04-.76,6.61-2.27,1.58-1.52,2.37-3.67,2.37-6.45,0-5.53-2.94-8.3-8.83-8.3h-3.37Zm19.94-.03c-.44,0-.82-.15-1.13-.45-.31-.3-.47-.68-.47-1.14s.16-.84.47-1.14c.31-.31.69-.47,1.13-.47s.83.16,1.15.47c.32.3.48.68.48,1.14s-.16.82-.48,1.13c-.31.31-.69.47-1.15.47Zm1.21,19.34h-2.47v-15.43h2.47v15.43Zm17.71,0h-2.47v-8.8c0-3.27-1.2-4.91-3.59-4.91-1.24,0-2.26.47-3.07,1.4-.8.92-1.21,2.09-1.21,3.51v8.8h-2.47v-15.43h2.47v2.56h.06c1.17-1.95,2.85-2.92,5.06-2.92,1.69,0,2.98.55,3.87,1.64.89,1.08,1.34,2.66,1.34,4.72v9.43Zm5.83-19.34c-.44,0-.82-.15-1.13-.45-.31-.3-.47-.68-.47-1.14s.16-.84.47-1.14c.31-.31.69-.47,1.13-.47s.83.16,1.15.47c.32.3.48.68.48,1.14s-.16.82-.48,1.13c-.31.31-.69.47-1.15.47Zm1.21,19.34h-2.47v-15.43h2.47v15.43Zm17.71,0h-2.47v-8.8c0-3.27-1.2-4.91-3.59-4.91-1.24,0-2.26.47-3.07,1.4-.8.92-1.21,2.09-1.21,3.51v8.8h-2.47v-15.43h2.47v2.56h.06c1.17-1.95,2.85-2.92,5.06-2.92,1.69,0,2.98.55,3.87,1.64.89,1.08,1.34,2.66,1.34,4.72v9.43Zm17.73-1.24c0,5.66-2.71,8.5-8.14,8.5-1.91,0-3.58-.36-5-1.08v-2.47c1.74.96,3.39,1.45,4.97,1.45,3.8,0,5.69-2.02,5.69-6.06v-1.69h-.06c-1.18,1.97-2.94,2.95-5.3,2.95-1.92,0-3.47-.68-4.64-2.05-1.17-1.38-1.75-3.22-1.75-5.53,0-2.62.63-4.71,1.88-6.25,1.27-1.55,2.99-2.32,5.18-2.32s3.62.83,4.63,2.5h.06v-2.14h2.47v14.19Zm-2.47-5.74v-2.27c0-1.23-.42-2.27-1.25-3.15-.82-.87-1.85-1.31-3.09-1.31-1.53,0-2.72.56-3.59,1.67-.86,1.1-1.3,2.66-1.3,4.66,0,1.72.41,3.09,1.24,4.13.83,1.02,1.93,1.54,3.3,1.54s2.51-.49,3.37-1.48c.87-.98,1.31-2.24,1.31-3.78Z" />
				<path d="m386.66,277.66h-3.01l-3.62-6.06c-.33-.56-.65-1.04-.96-1.43-.31-.4-.63-.73-.96-.98-.32-.25-.67-.43-1.05-.54-.37-.12-.79-.18-1.27-.18h-2.08v9.19h-2.53v-21.6h6.45c.94,0,1.81.12,2.61.36.8.23,1.5.59,2.08,1.07.59.48,1.05,1.08,1.39,1.81.33.71.5,1.55.5,2.52,0,.75-.12,1.45-.35,2.08-.22.62-.54,1.18-.96,1.67-.41.49-.91.91-1.51,1.27-.58.34-1.24.61-1.97.8v.06c.36.16.67.35.93.56.27.2.53.44.77.72.24.28.48.6.71.96.24.35.51.76.8,1.24l4.05,6.49Zm-12.96-19.31v7.83h3.44c.63,0,1.22-.1,1.75-.29.54-.19,1.01-.46,1.4-.81.39-.36.7-.8.92-1.31.22-.52.33-1.1.33-1.75,0-1.16-.38-2.05-1.13-2.7-.74-.65-1.82-.98-3.24-.98h-3.47Zm21.95,19.68c-2.28,0-4.1-.72-5.47-2.15-1.36-1.45-2.03-3.36-2.03-5.74,0-2.59.71-4.62,2.12-6.07,1.42-1.46,3.33-2.18,5.74-2.18s4.09.71,5.38,2.12c1.3,1.42,1.94,3.38,1.94,5.89s-.7,4.43-2.09,5.92c-1.39,1.48-3.25,2.21-5.59,2.21Zm.18-14.07c-1.59,0-2.84.54-3.77,1.63-.92,1.07-1.39,2.56-1.39,4.46s.47,3.27,1.4,4.32c.93,1.05,2.18,1.58,3.75,1.58s2.82-.52,3.68-1.55c.86-1.03,1.3-2.51,1.3-4.41s-.43-3.41-1.3-4.46c-.85-1.04-2.08-1.57-3.68-1.57Zm17.81,14.07c-2.28,0-4.1-.72-5.47-2.15-1.36-1.45-2.03-3.36-2.03-5.74,0-2.59.71-4.62,2.12-6.07,1.42-1.46,3.33-2.18,5.74-2.18s4.09.71,5.38,2.12c1.3,1.42,1.94,3.38,1.94,5.89s-.7,4.43-2.09,5.92c-1.39,1.48-3.25,2.21-5.59,2.21Zm.18-14.07c-1.59,0-2.84.54-3.77,1.63-.92,1.07-1.39,2.56-1.39,4.46s.47,3.27,1.4,4.32c.93,1.05,2.18,1.58,3.75,1.58s2.82-.52,3.68-1.55c.86-1.03,1.3-2.51,1.3-4.41s-.43-3.41-1.3-4.46c-.85-1.04-2.08-1.57-3.68-1.57Zm33.27,13.71h-2.47v-8.86c0-1.71-.27-2.94-.8-3.71-.52-.76-1.41-1.14-2.65-1.14-1.05,0-1.95.48-2.7,1.45-.73.96-1.1,2.12-1.1,3.47v8.8h-2.47v-9.16c0-3.03-1.17-4.55-3.51-4.55-1.08,0-1.98.46-2.68,1.37-.7.9-1.05,2.08-1.05,3.54v8.8h-2.47v-15.43h2.47v2.44h.06c1.09-1.87,2.69-2.8,4.79-2.8,1.05,0,1.97.3,2.76.89.78.58,1.32,1.35,1.61,2.31,1.15-2.13,2.85-3.19,5.12-3.19,3.39,0,5.09,2.09,5.09,6.28v9.51Z" />
				<path d="m260.09,309.69h-1.8v-13.58c-.14.14-.34.3-.61.48-.26.18-.56.35-.9.53-.33.18-.68.34-1.05.49-.37.15-.72.27-1.07.36v-1.82c.39-.11.81-.26,1.25-.44.45-.19.88-.4,1.3-.62.43-.23.84-.48,1.22-.72.38-.26.71-.5.99-.75h.68v16.07Zm14.63-4.45c0,.71-.14,1.36-.41,1.94-.26.58-.64,1.07-1.13,1.49-.48.41-1.06.73-1.74.95-.68.23-1.43.34-2.25.34-1.5,0-2.69-.29-3.57-.86v-1.93c1.06.83,2.27,1.25,3.64,1.25.55,0,1.04-.07,1.48-.21.45-.14.83-.34,1.14-.6.32-.26.57-.58.73-.95.18-.37.26-.79.26-1.26,0-2.05-1.46-3.08-4.39-3.08h-1.3v-1.52h1.24c2.59,0,3.88-.96,3.88-2.89,0-1.78-.99-2.67-2.96-2.67-1.11,0-2.15.37-3.12,1.12v-1.74c1-.6,2.19-.9,3.57-.9.66,0,1.25.09,1.79.27.53.18.99.44,1.37.77.38.33.67.72.88,1.18.21.46.32.97.32,1.52,0,2.07-1.05,3.4-3.14,3.99v.04c.53.06,1.03.19,1.48.39.45.2.84.46,1.17.78.33.32.58.7.77,1.14.19.43.29.91.29,1.44Z" />
				<rect x="278.18" y="293.97" width="1.59" height="4.9" />
				<path d="m290.8,293.97v10.38h2.02v1.64h-2.02v3.69h-1.78v-3.69h-7.39v-1.56c.69-.77,1.38-1.6,2.08-2.48.7-.88,1.37-1.78,2.01-2.69.64-.91,1.24-1.81,1.78-2.71.55-.91,1.01-1.77,1.38-2.6h1.92Zm-7.14,10.38h5.36v-7.7c-.55.96-1.07,1.81-1.56,2.57-.49.75-.96,1.44-1.4,2.05-.44.61-.86,1.17-1.26,1.67-.4.5-.78.97-1.14,1.41Z" />
				<path d="m296.97,293.97v4.9h-1.59v-4.9h1.59Zm3.64,0v4.9h-1.59v-4.9h1.59Z" />
				<path d="m318.58,298.47l-3.77,5.68,3.71,5.55h-2.09l-2.2-3.64c-.14-.23-.3-.51-.49-.86h-.04c-.04.07-.21.35-.52.86l-2.25,3.64h-2.07l3.83-5.5-3.66-5.72h2.09l2.17,3.84c.16.28.32.58.47.88h.04l2.81-4.71h1.98Z" />
				<path d="m332.96,309.69h-1.8v-13.58c-.14.14-.34.3-.61.48-.26.18-.56.35-.9.53-.33.18-.68.34-1.05.49-.37.15-.72.27-1.07.36v-1.82c.39-.11.81-.26,1.25-.44.45-.19.88-.4,1.3-.62.43-.23.84-.48,1.22-.72.38-.26.71-.5.99-.75h.68v16.07Zm15.36-7.93c0,1.32-.12,2.48-.36,3.5-.23,1.02-.58,1.87-1.03,2.58-.45.69-1,1.22-1.66,1.59-.65.36-1.39.54-2.23.54-.79,0-1.49-.17-2.12-.52-.61-.35-1.13-.86-1.56-1.52-.42-.67-.75-1.48-.96-2.44-.22-.97-.33-2.08-.33-3.33,0-1.37.11-2.59.34-3.64.23-1.05.57-1.93,1.02-2.64.45-.72,1-1.25,1.66-1.61.67-.37,1.43-.55,2.28-.55,3.3,0,4.94,2.69,4.94,8.06Zm-1.84.18c0-4.47-1.06-6.71-3.19-6.71-2.24,0-3.37,2.28-3.37,6.83,0,4.25,1.1,6.37,3.3,6.37s3.26-2.16,3.26-6.49Z" />
				<rect x="351.05" y="293.97" width="1.59" height="4.9" />
				<path d="m355.33,305.31c0-.42.07-.83.2-1.25.13-.42.32-.82.56-1.18.25-.37.55-.7.91-1,.37-.3.78-.54,1.24-.71-.68-.38-1.22-.87-1.62-1.46-.4-.6-.6-1.26-.6-1.98,0-.58.11-1.11.33-1.6.23-.49.54-.91.93-1.27.39-.36.86-.64,1.4-.83.54-.2,1.13-.31,1.75-.31s1.22.1,1.76.31,1.01.49,1.4.84c.39.36.7.78.92,1.27.22.49.33,1.02.33,1.59,0,.72-.2,1.38-.6,1.98-.4.59-.94,1.08-1.6,1.46.45.18.86.41,1.22.71.36.3.66.63.9,1,.25.37.44.76.57,1.18.13.42.2.83.2,1.25,0,.69-.12,1.32-.37,1.89-.25.57-.6,1.06-1.05,1.47-.45.4-.98.72-1.61.94-.62.23-1.31.34-2.06.34s-1.43-.11-2.05-.34c-.62-.23-1.16-.54-1.61-.94-.45-.41-.81-.9-1.06-1.47-.25-.57-.37-1.2-.37-1.89Zm1.95-.15c0,.49.07.93.22,1.33.15.39.37.73.64,1.01.28.28.61.49,1,.65.39.15.83.22,1.3.22s.88-.08,1.27-.23.72-.37,1-.65c.29-.28.5-.61.66-1.01.16-.39.24-.83.24-1.32,0-.44-.08-.85-.23-1.23-.15-.39-.36-.73-.64-1.02-.28-.29-.61-.52-1-.69-.39-.17-.82-.25-1.3-.25-.45,0-.87.08-1.26.24-.38.15-.71.37-1,.66-.28.28-.5.61-.66,1.01-.16.39-.24.81-.24,1.28Zm.56-7.29c0,.37.07.72.2,1.04.14.31.33.59.56.83.24.23.52.42.83.56.31.13.65.2,1.01.2s.69-.07,1.01-.21c.32-.14.6-.33.83-.56.23-.24.42-.52.56-.83.14-.32.21-.67.21-1.03s-.07-.73-.21-1.05c-.13-.32-.31-.6-.55-.83s-.51-.42-.83-.55c-.31-.14-.65-.21-1.02-.21-.39,0-.74.07-1.06.21-.31.14-.59.33-.82.57-.23.23-.4.51-.53.83-.12.32-.19.67-.19,1.03Z" />
				<path d="m369.84,293.97v4.9h-1.59v-4.9h1.59Zm3.64,0v4.9h-1.59v-4.9h1.59Z" />
				<path d="m687.52,304.7v-21.6h6.15c1.87,0,3.35.46,4.44,1.37,1.09.91,1.64,2.1,1.64,3.57,0,1.23-.33,2.29-.99,3.19-.66.9-1.58,1.55-2.74,1.93v.06c1.46.17,2.62.72,3.5,1.66.87.92,1.31,2.13,1.31,3.62,0,1.85-.66,3.34-1.99,4.49-1.33,1.14-3,1.72-5.02,1.72h-6.3Zm2.53-19.31v6.98h2.59c1.39,0,2.48-.33,3.27-.99.79-.67,1.19-1.62,1.19-2.83,0-2.1-1.38-3.15-4.14-3.15h-2.91Zm0,9.25v7.77h3.44c1.49,0,2.64-.35,3.45-1.05.82-.7,1.24-1.67,1.24-2.89,0-2.55-1.74-3.83-5.21-3.83h-2.91Zm27.19,2.97h-10.89c.04,1.72.5,3.04,1.39,3.98.88.93,2.1,1.4,3.65,1.4,1.74,0,3.33-.57,4.79-1.72v2.32c-1.36.98-3.15,1.48-5.38,1.48s-3.89-.7-5.14-2.09c-1.25-1.41-1.87-3.38-1.87-5.92,0-2.4.68-4.35,2.03-5.86,1.37-1.52,3.06-2.27,5.08-2.27s3.58.65,4.69,1.96c1.1,1.31,1.66,3.12,1.66,5.44v1.3Zm-2.53-2.09c-.01-1.43-.36-2.54-1.04-3.33-.67-.79-1.61-1.19-2.82-1.19s-2.15.42-2.97,1.25c-.81.83-1.32,1.92-1.51,3.27h8.33Zm19.41,9.19h-2.47v-2.62h-.06c-1.14,1.99-2.91,2.98-5.3,2.98-1.94,0-3.49-.69-4.66-2.06-1.16-1.39-1.73-3.27-1.73-5.65,0-2.55.64-4.6,1.93-6.13,1.29-1.54,3-2.31,5.14-2.31s3.66.83,4.63,2.5h.06v-9.55h2.47v22.84Zm-2.47-6.98v-2.27c0-1.25-.41-2.3-1.24-3.16-.82-.86-1.87-1.3-3.13-1.3-1.51,0-2.69.55-3.56,1.66-.86,1.1-1.3,2.63-1.3,4.58,0,1.78.41,3.18,1.24,4.22.83,1.02,1.95,1.54,3.34,1.54s2.49-.5,3.34-1.49c.86-.99,1.3-2.25,1.3-3.77Zm15.5-5.95c-.43-.33-1.05-.5-1.87-.5-1.05,0-1.94.5-2.65,1.49-.7.99-1.05,2.35-1.05,4.07v7.86h-2.47v-15.43h2.47v3.18h.06c.35-1.08.89-1.93,1.61-2.53.72-.61,1.53-.92,2.43-.92.64,0,1.13.07,1.48.21v2.56Zm9.12,13.29c-2.28,0-4.1-.72-5.47-2.15-1.36-1.45-2.03-3.36-2.03-5.74,0-2.59.71-4.62,2.12-6.07,1.42-1.46,3.33-2.18,5.74-2.18s4.09.71,5.38,2.12c1.3,1.42,1.94,3.38,1.94,5.89s-.7,4.43-2.09,5.92c-1.39,1.48-3.25,2.21-5.59,2.21Zm.18-14.07c-1.59,0-2.84.54-3.77,1.63-.92,1.07-1.39,2.56-1.39,4.46s.47,3.27,1.4,4.32,2.18,1.58,3.75,1.58,2.82-.52,3.68-1.55c.86-1.03,1.3-2.51,1.3-4.41s-.43-3.41-1.3-4.46c-.85-1.04-2.08-1.57-3.68-1.57Zm17.88,14.07c-2.28,0-4.1-.72-5.47-2.15-1.36-1.45-2.03-3.36-2.03-5.74,0-2.59.71-4.62,2.12-6.07,1.42-1.46,3.33-2.18,5.74-2.18s4.09.71,5.38,2.12c1.3,1.42,1.94,3.38,1.94,5.89s-.7,4.43-2.09,5.92c-1.39,1.48-3.25,2.21-5.59,2.21Zm.18-14.07c-1.59,0-2.84.54-3.77,1.63-.92,1.07-1.39,2.56-1.39,4.46s.47,3.27,1.4,4.32,2.18,1.58,3.75,1.58,2.82-.52,3.68-1.55c.86-1.03,1.3-2.51,1.3-4.41s-.43-3.41-1.3-4.46c-.85-1.04-2.08-1.57-3.68-1.57Zm33.33,13.71h-2.47v-8.86c0-1.71-.27-2.94-.8-3.71-.52-.76-1.41-1.15-2.65-1.15-1.05,0-1.95.48-2.7,1.45-.73.96-1.1,2.12-1.1,3.47v8.8h-2.47v-9.16c0-3.03-1.17-4.55-3.51-4.55-1.08,0-1.98.46-2.68,1.37-.7.9-1.05,2.08-1.05,3.54v8.8h-2.47v-15.43h2.47v2.44h.06c1.09-1.87,2.69-2.8,4.79-2.8,1.05,0,1.97.3,2.76.89.78.58,1.32,1.35,1.61,2.31,1.15-2.13,2.85-3.19,5.12-3.19,3.39,0,5.09,2.09,5.09,6.28v9.51Z" />
				<path d="m693.7,336.73h-1.8v-13.58c-.14.14-.34.3-.61.48-.26.18-.56.35-.9.53-.33.18-.68.34-1.05.49-.37.15-.72.27-1.07.36v-1.82c.39-.11.81-.26,1.25-.44.45-.19.88-.4,1.3-.62.43-.23.84-.48,1.22-.72.38-.26.71-.5.99-.75h.68v16.07Zm15.36-7.93c0,1.32-.12,2.48-.36,3.5-.23,1.02-.58,1.87-1.03,2.58-.45.69-1,1.22-1.66,1.59-.65.36-1.39.54-2.23.54-.79,0-1.49-.17-2.12-.52-.61-.35-1.13-.86-1.56-1.52-.42-.67-.75-1.48-.96-2.44-.22-.97-.33-2.08-.33-3.33,0-1.37.11-2.59.34-3.64.23-1.05.57-1.93,1.02-2.64.45-.72,1-1.25,1.66-1.61.67-.37,1.43-.55,2.28-.55,3.3,0,4.94,2.69,4.94,8.06Zm-1.84.18c0-4.47-1.06-6.71-3.19-6.71-2.24,0-3.37,2.28-3.37,6.83,0,4.25,1.1,6.37,3.3,6.37s3.26-2.16,3.26-6.49Z" />
				<rect x="711.79" y="321.01" width="1.59" height="4.9" />
				<path d="m723.02,336.73h-1.8v-13.58c-.14.14-.34.3-.61.48-.26.18-.56.35-.9.53-.33.18-.68.34-1.05.49-.37.15-.72.27-1.07.36v-1.82c.39-.11.81-.26,1.25-.44.45-.19.88-.4,1.3-.62.43-.23.84-.48,1.22-.72.38-.26.71-.5.99-.75h.68v16.07Z" />
				<path d="m730.58,321.01v4.9h-1.59v-4.9h1.59Zm3.64,0v4.9h-1.59v-4.9h1.59Z" />
				<path d="m752.19,325.51l-3.77,5.68,3.71,5.55h-2.09l-2.2-3.64c-.14-.23-.3-.51-.49-.86h-.04c-.04.07-.21.35-.52.86l-2.25,3.64h-2.07l3.83-5.5-3.66-5.72h2.09l2.17,3.84c.16.29.32.58.47.88h.04l2.81-4.71h1.98Z" />
				<path d="m766.56,336.73h-1.8v-13.58c-.14.14-.34.3-.61.48-.26.18-.56.35-.9.53-.33.18-.68.34-1.05.49-.37.15-.72.27-1.07.36v-1.82c.39-.11.81-.26,1.25-.44.45-.19.88-.4,1.3-.62.43-.23.84-.48,1.22-.72.38-.26.71-.5.99-.75h.68v16.07Zm12.65-11.6c0-.48-.08-.9-.23-1.26-.15-.36-.35-.65-.61-.89-.26-.24-.56-.42-.91-.54-.35-.12-.73-.18-1.14-.18-.35,0-.69.05-1.03.14s-.67.23-.99.39c-.31.17-.62.37-.92.6-.29.23-.57.49-.82.78v-1.93c.5-.49,1.07-.86,1.69-1.12.63-.26,1.39-.39,2.29-.39.64,0,1.24.09,1.79.29.55.18,1.02.45,1.43.81.4.36.72.8.94,1.33.23.53.35,1.13.35,1.81,0,.62-.07,1.18-.22,1.69-.14.5-.35.98-.65,1.43-.29.45-.65.87-1.09,1.28-.44.41-.95.83-1.55,1.25-.74.53-1.35.98-1.83,1.35-.48.37-.86.72-1.14,1.05-.28.32-.48.65-.59.98-.11.32-.16.69-.16,1.12h7.83v1.61h-9.7v-.78c0-.67.07-1.26.22-1.78s.39-1,.72-1.46c.34-.46.77-.92,1.32-1.38.55-.46,1.22-.98,2.01-1.56.57-.41,1.05-.8,1.43-1.17.39-.37.7-.75.93-1.12s.4-.75.49-1.13c.1-.39.15-.8.15-1.23Z" />
				<rect x="784.65" y="321.01" width="1.59" height="4.9" />
				<path d="m798.4,332.28c0,.71-.14,1.36-.41,1.94-.26.58-.64,1.07-1.13,1.49-.48.41-1.06.73-1.74.95-.68.23-1.43.34-2.25.34-1.5,0-2.69-.29-3.57-.86v-1.93c1.06.83,2.27,1.25,3.64,1.25.55,0,1.04-.07,1.48-.21.45-.14.83-.34,1.14-.6.32-.26.57-.58.73-.95.18-.37.26-.79.26-1.26,0-2.05-1.46-3.08-4.39-3.08h-1.3v-1.52h1.24c2.59,0,3.88-.96,3.88-2.89,0-1.78-.99-2.67-2.96-2.67-1.11,0-2.15.37-3.12,1.12v-1.74c1-.6,2.19-.9,3.57-.9.66,0,1.25.09,1.79.27.53.18.99.44,1.37.77.38.33.67.72.88,1.18.21.46.32.97.32,1.52,0,2.07-1.05,3.4-3.14,3.99v.04c.53.06,1.03.19,1.48.39.45.2.84.46,1.17.78.33.32.58.7.77,1.14.19.43.29.91.29,1.44Z" />
				<path d="m803.45,321.01v4.9h-1.59v-4.9h1.59Zm3.64,0v4.9h-1.59v-4.9h1.59Z" />
				<path d="m331.91,674.97h-3.53l-8.35-9.88c-.31-.37-.5-.62-.57-.75h-.06v10.64h-2.53v-21.6h2.53v10.15h.06c.14-.22.33-.47.57-.74l8.08-9.42h3.15l-9.27,10.37,9.91,11.24Zm3.78-19.34c-.44,0-.82-.15-1.13-.45-.31-.3-.47-.68-.47-1.15s.16-.84.47-1.15c.31-.31.69-.47,1.13-.47s.83.16,1.15.47c.32.3.48.68.48,1.15s-.16.82-.48,1.13c-.31.31-.69.47-1.15.47Zm1.21,19.34h-2.47v-15.43h2.47v15.43Zm12.13-.15c-.58.32-1.35.48-2.31.48-2.7,0-4.05-1.51-4.05-4.52v-9.13h-2.65v-2.11h2.65v-3.77l2.47-.8v4.57h3.89v2.11h-3.89v8.69c0,1.03.18,1.77.53,2.21.35.44.93.66,1.75.66.62,0,1.16-.17,1.61-.51v2.11Zm13.8-.56c-1.19.71-2.59,1.07-4.22,1.07-2.2,0-3.98-.71-5.33-2.14-1.35-1.44-2.02-3.29-2.02-5.57,0-2.54.73-4.58,2.18-6.12,1.46-1.55,3.4-2.32,5.83-2.32,1.36,0,2.55.25,3.59.75v2.53c-1.14-.8-2.37-1.21-3.68-1.21-1.58,0-2.87.57-3.89,1.7-1,1.12-1.51,2.61-1.51,4.44s.47,3.23,1.42,4.28c.95,1.04,2.23,1.57,3.83,1.57,1.35,0,2.61-.45,3.8-1.34v2.35Zm16.53.71h-2.47v-8.89c0-3.21-1.2-4.82-3.59-4.82-1.21,0-2.22.47-3.04,1.4-.82.92-1.24,2.11-1.24,3.57v8.74h-2.47v-22.84h2.47v9.97h.06c1.19-1.95,2.87-2.92,5.06-2.92,3.48,0,5.21,2.09,5.21,6.28v9.51Zm17.04-7.1h-10.89c.04,1.72.5,3.04,1.39,3.98.88.93,2.1,1.4,3.65,1.4,1.74,0,3.33-.57,4.79-1.72v2.32c-1.36.98-3.15,1.48-5.38,1.48s-3.89-.7-5.14-2.09c-1.25-1.41-1.87-3.38-1.87-5.92,0-2.4.68-4.35,2.03-5.86,1.37-1.52,3.06-2.27,5.08-2.27s3.58.65,4.69,1.96c1.1,1.31,1.66,3.12,1.66,5.44v1.3Zm-2.53-2.09c-.01-1.43-.36-2.54-1.04-3.33-.67-.79-1.61-1.19-2.82-1.19s-2.15.42-2.97,1.25c-.81.83-1.32,1.92-1.51,3.27h8.33Zm19.06,9.19h-2.47v-8.8c0-3.27-1.2-4.91-3.59-4.91-1.24,0-2.26.47-3.07,1.4-.8.92-1.21,2.09-1.21,3.51v8.8h-2.47v-15.43h2.47v2.56h.06c1.17-1.95,2.85-2.92,5.06-2.92,1.69,0,2.98.55,3.87,1.64.89,1.08,1.34,2.66,1.34,4.72v9.43Z" />
				<path d="m449.96,747.09h-11.45v-21.6h10.97v2.29h-8.44v7.19h7.8v2.27h-7.8v7.56h8.92v2.29Zm16.66,0h-2.47v-8.8c0-3.27-1.2-4.91-3.59-4.91-1.24,0-2.26.47-3.07,1.4-.8.92-1.21,2.09-1.21,3.51v8.8h-2.47v-15.43h2.47v2.56h.06c1.17-1.95,2.85-2.92,5.06-2.92,1.69,0,2.98.55,3.87,1.64.89,1.08,1.34,2.66,1.34,4.72v9.43Zm11.84-.15c-.58.32-1.35.48-2.31.48-2.7,0-4.05-1.51-4.05-4.52v-9.13h-2.65v-2.11h2.65v-3.77l2.47-.8v4.57h3.89v2.11h-3.89v8.69c0,1.03.18,1.77.53,2.21.35.44.93.66,1.75.66.62,0,1.16-.17,1.61-.51v2.11Zm11.37-12.78c-.43-.33-1.05-.5-1.87-.5-1.05,0-1.94.5-2.65,1.49-.7.99-1.05,2.35-1.05,4.07v7.86h-2.47v-15.43h2.47v3.18h.06c.35-1.08.89-1.93,1.61-2.53.72-.61,1.53-.92,2.43-.92.64,0,1.13.07,1.48.21v2.56Zm15-2.5l-7.1,17.9c-1.27,3.19-3.04,4.79-5.33,4.79-.64,0-1.18-.07-1.61-.2v-2.21c.53.18,1.02.27,1.46.27,1.25,0,2.18-.74,2.8-2.23l1.24-2.92-6.03-15.4h2.74l4.17,11.87c.05.15.16.54.32,1.18h.09c.05-.24.15-.62.3-1.14l4.38-11.9h2.56Z" />
				<path d="m751.43,765.4v-21.6h6.15c1.87,0,3.35.46,4.44,1.37,1.09.91,1.64,2.1,1.64,3.57,0,1.23-.33,2.29-.99,3.19s-1.58,1.55-2.74,1.93v.06c1.46.17,2.62.72,3.5,1.66.87.92,1.31,2.13,1.31,3.62,0,1.85-.66,3.34-1.99,4.49-1.33,1.15-3,1.72-5.02,1.72h-6.3Zm2.53-19.31v6.98h2.59c1.39,0,2.48-.33,3.27-.99.79-.67,1.19-1.62,1.19-2.83,0-2.1-1.38-3.15-4.14-3.15h-2.91Zm0,9.25v7.77h3.44c1.49,0,2.64-.35,3.45-1.05.82-.7,1.24-1.67,1.24-2.89,0-2.55-1.74-3.83-5.21-3.83h-2.91Zm25.86,10.06h-2.47v-2.41h-.06c-1.07,1.85-2.66,2.77-4.75,2.77-1.54,0-2.74-.41-3.62-1.22-.86-.81-1.3-1.89-1.3-3.24,0-2.88,1.7-4.56,5.09-5.03l4.63-.65c0-2.62-1.06-3.93-3.18-3.93-1.86,0-3.54.63-5.03,1.9v-2.53c1.52-.96,3.26-1.45,5.24-1.45,3.63,0,5.44,1.92,5.44,5.76v10.03Zm-2.47-7.8l-3.72.51c-1.15.16-2.01.45-2.59.86-.58.4-.87,1.12-.87,2.15,0,.75.27,1.37.8,1.85.54.47,1.26.71,2.15.71,1.23,0,2.23-.43,3.03-1.28.8-.86,1.21-1.95,1.21-3.27v-1.54Zm14.29,7.65c-.58.32-1.35.48-2.31.48-2.7,0-4.05-1.51-4.05-4.52v-9.13h-2.65v-2.11h2.65v-3.77l2.47-.8v4.56h3.89v2.11h-3.89v8.69c0,1.03.18,1.77.53,2.21.35.44.93.66,1.75.66.62,0,1.16-.17,1.61-.51v2.11Zm16.11.15h-2.47v-8.89c0-3.21-1.2-4.82-3.59-4.82-1.21,0-2.22.47-3.04,1.4-.82.92-1.24,2.11-1.24,3.57v8.74h-2.47v-22.84h2.47v9.97h.06c1.19-1.95,2.87-2.92,5.06-2.92,3.48,0,5.21,2.09,5.21,6.28v9.51Z" />
				<path d="m606.48,870.38l-3.88,13.74h-1.89l-2.83-10.04c-.12-.43-.19-.89-.22-1.4h-.04c-.04.47-.12.93-.25,1.38l-2.85,10.06h-1.87l-4.03-13.74h1.77l2.92,10.54c.12.44.2.9.23,1.38h.05c.03-.34.13-.8.3-1.38l3.04-10.54h1.54l2.91,10.62c.1.36.18.79.23,1.28h.04c.03-.33.11-.77.26-1.32l2.81-10.58h1.74Z" />
				<polygon points="614.5 870.38 607.91 886.4 606.44 886.4 613.02 870.38 614.5 870.38" />
				<path d="m616.11,884.12v-13.74h3.8c4.84,0,7.27,2.23,7.27,6.7,0,2.12-.67,3.83-2.02,5.12-1.34,1.28-3.14,1.93-5.4,1.93h-3.64Zm1.61-12.29v10.83h2.05c1.8,0,3.2-.48,4.21-1.45,1-.96,1.5-2.33,1.5-4.1,0-3.52-1.87-5.28-5.62-5.28h-2.15Z" />
			</g>
		</g>
	)
}

export default PlanII
